export default Object.freeze({
  countries: [
    {
      'name': {
        'common': 'Aruba',
        'official': 'Aruba',
        'native': {
          'nld': {
            'official': 'Aruba',
            'common': 'Aruba'
          },
          'pap': {
            'official': 'Aruba',
            'common': 'Aruba'
          }
        }
      },
      'tld': [
        '.aw'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde6\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Afghanistan',
        'official': 'Islamic Republic of Afghanistan',
        'native': {
          'prs': {
            'official': '\u062c\u0645\u0647\u0648\u0631\u06cc \u0627\u0633\u0644\u0627\u0645\u06cc \u0627\u0641\u063a\u0627\u0646\u0633\u062a\u0627\u0646',
            'common': '\u0627\u0641\u063a\u0627\u0646\u0633\u062a\u0627\u0646'
          },
          'pus': {
            'official': '\u062f \u0627\u0641\u063a\u0627\u0646\u0633\u062a\u0627\u0646 \u0627\u0633\u0644\u0627\u0645\u064a \u062c\u0645\u0647\u0648\u0631\u06cc\u062a',
            'common': '\u0627\u0641\u063a\u0627\u0646\u0633\u062a\u0627\u0646'
          },
          'tuk': {
            'official': 'Owganystan Yslam Respublikasy',
            'common': 'Owganystan'
          }
        }
      },
      'tld': [
        '.af'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\udde6\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Angola',
        'official': 'Republic of Angola',
        'native': {
          'por': {
            'official': 'Rep\u00fablica de Angola',
            'common': 'Angola'
          }
        }
      },
      'tld': [
        '.ao'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\udde6\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Anguilla',
        'official': 'Anguilla',
        'native': {
          'eng': {
            'official': 'Anguilla',
            'common': 'Anguilla'
          }
        }
      },
      'tld': [
        '.ai'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde6\ud83c\uddee'

    },
    {
      'name': {
        'common': '\u00c5land Islands',
        'official': '\u00c5land Islands',
        'native': {
          'swe': {
            'official': 'Landskapet \u00c5land',
            'common': '\u00c5land'
          }
        }
      },
      'tld': [
        '.ax'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\udde6\ud83c\uddfd'

    },
    {
      'name': {
        'common': 'Albania',
        'official': 'Republic of Albania',
        'native': {
          'sqi': {
            'official': 'Republika e Shqip\u00ebris\u00eb',
            'common': 'Shqip\u00ebria'
          }
        }
      },
      'tld': [
        '.al'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\udde6\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'Andorra',
        'official': 'Principality of Andorra',
        'native': {
          'cat': {
            'official': "Principat d'Andorra",
            'common': 'Andorra'
          }
        }
      },
      'tld': [
        '.ad'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\udde6\ud83c\udde9'

    },
    {
      'name': {
        'common': 'United Arab Emirates',
        'official': 'United Arab Emirates',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062a \u0627\u0644\u0639\u0631\u0628\u064a\u0629 \u0627\u0644\u0645\u062a\u062d\u062f\u0629',
            'common': '\u062f\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062a \u0627\u0644\u0639\u0631\u0628\u064a\u0629 \u0627\u0644\u0645\u062a\u062d\u062f\u0629'
          }
        }
      },
      'tld': [
        '.ae',
        '\u0627\u0645\u0627\u0631\u0627\u062a.'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\udde6\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Argentina',
        'official': 'Argentine Republic',
        'native': {
          'grn': {
            'official': 'Argentine Republic',
            'common': 'Argentina'
          },
          'spa': {
            'official': 'Rep\u00fablica Argentina',
            'common': 'Argentina'
          }
        }
      },
      'tld': [
        '.ar'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\udde6\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Armenia',
        'official': 'Republic of Armenia',
        'native': {
          'hye': {
            'official': '\u0540\u0561\u0575\u0561\u057d\u057f\u0561\u0576\u056b \u0540\u0561\u0576\u0580\u0561\u057a\u0565\u057f\u0578\u0582\u0569\u0575\u0578\u0582\u0576',
            'common': '\u0540\u0561\u0575\u0561\u057d\u057f\u0561\u0576'
          }
        }
      },
      'tld': [
        '.am'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\udde6\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'American Samoa',
        'official': 'American Samoa',
        'native': {
          'eng': {
            'official': 'American Samoa',
            'common': 'American Samoa'
          },
          'smo': {
            'official': 'S\u0101moa Amelika',
            'common': 'S\u0101moa Amelika'
          }
        }
      },
      'tld': [
        '.as'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\udde6\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Antarctica',
        'official': 'Antarctica',
        'native': {}
      },
      'tld': [
        '.aq'
      ],
      'region': 'Antarctic',
      'subregion': '',
      'flag': '\ud83c\udde6\ud83c\uddf6'

    },
    {
      'name': {
        'common': 'French Southern and Antarctic Lands',
        'official': 'Territory of the French Southern and Antarctic Lands',
        'native': {
          'fra': {
            'official': 'Territoire des Terres australes et antarctiques fran\u00e7aises',
            'common': 'Terres australes et antarctiques fran\u00e7aises'
          }
        }
      },
      'tld': [
        '.tf'
      ],
      'region': 'Antarctic',
      'subregion': '',
      'flag': '\ud83c\uddf9\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Antigua and Barbuda',
        'official': 'Antigua and Barbuda',
        'native': {
          'eng': {
            'official': 'Antigua and Barbuda',
            'common': 'Antigua and Barbuda'
          }
        }
      },
      'tld': [
        '.ag'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde6\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Australia',
        'official': 'Commonwealth of Australia',
        'native': {
          'eng': {
            'official': 'Commonwealth of Australia',
            'common': 'Australia'
          }
        }
      },
      'tld': [
        '.au'
      ],
      'region': 'Oceania',
      'subregion': 'Australia and New Zealand',
      'flag': '\ud83c\udde6\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Austria',
        'official': 'Republic of Austria',
        'native': {
          'bar': {
            'official': 'Republik \u00d6sterreich',
            'common': '\u00d6sterreich'
          }
        }
      },
      'tld': [
        '.at'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\udde6\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Azerbaijan',
        'official': 'Republic of Azerbaijan',
        'native': {
          'aze': {
            'official': 'Az\u0259rbaycan Respublikas\u0131',
            'common': 'Az\u0259rbaycan'
          },
          'rus': {
            'official': '\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043d\u0441\u043a\u0430\u044f \u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430',
            'common': '\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043d'
          }
        }
      },
      'tld': [
        '.az'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\udde6\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Burundi',
        'official': 'Republic of Burundi',
        'native': {
          'fra': {
            'official': 'R\u00e9publique du Burundi',
            'common': 'Burundi'
          },
          'run': {
            'official': "Republika y'Uburundi ",
            'common': 'Uburundi'
          }
        }
      },
      'tld': [
        '.bi'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\udde7\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Belgium',
        'official': 'Kingdom of Belgium',
        'native': {
          'deu': {
            'official': 'K\u00f6nigreich Belgien',
            'common': 'Belgien'
          },
          'fra': {
            'official': 'Royaume de Belgique',
            'common': 'Belgique'
          },
          'nld': {
            'official': 'Koninkrijk Belgi\u00eb',
            'common': 'Belgi\u00eb'
          }
        }
      },
      'tld': [
        '.be'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\udde7\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Benin',
        'official': 'Republic of Benin',
        'native': {
          'fra': {
            'official': 'R\u00e9publique du B\u00e9nin',
            'common': 'B\u00e9nin'
          }
        }
      },
      'tld': [
        '.bj'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\udde7\ud83c\uddef'

    },
    {
      'name': {
        'common': 'Burkina Faso',
        'official': 'Burkina Faso',
        'native': {
          'fra': {
            'official': 'R\u00e9publique du Burkina',
            'common': 'Burkina Faso'
          }
        }
      },
      'tld': [
        '.bf'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\udde7\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Bangladesh',
        'official': "People's Republic of Bangladesh",
        'native': {
          'ben': {
            'official': '\u09ac\u09be\u0982\u09b2\u09be\u09a6\u09c7\u09b6 \u0997\u09a3\u09aa\u09cd\u09b0\u099c\u09be\u09a4\u09a8\u09cd\u09a4\u09cd\u09b0\u09c0',
            'common': '\u09ac\u09be\u0982\u09b2\u09be\u09a6\u09c7\u09b6'
          }
        }
      },
      'tld': [
        '.bd'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\udde7\ud83c\udde9'

    },
    {
      'name': {
        'common': 'Bulgaria',
        'official': 'Republic of Bulgaria',
        'native': {
          'bul': {
            'official': '\u0420\u0435\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u0411\u044a\u043b\u0433\u0430\u0440\u0438\u044f',
            'common': '\u0411\u044a\u043b\u0433\u0430\u0440\u0438\u044f'
          }
        }
      },
      'tld': [
        '.bg'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\udde7\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Bahrain',
        'official': 'Kingdom of Bahrain',
        'native': {
          'ara': {
            'official': '\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0628\u062d\u0631\u064a\u0646',
            'common': '\u200f\u0627\u0644\u0628\u062d\u0631\u064a\u0646'
          }
        }
      },
      'tld': [
        '.bh'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\udde7\ud83c\udded'

    },
    {
      'name': {
        'common': 'Bahamas',
        'official': 'Commonwealth of the Bahamas',
        'native': {
          'eng': {
            'official': 'Commonwealth of the Bahamas',
            'common': 'Bahamas'
          }
        }
      },
      'tld': [
        '.bs'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde7\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Bosnia and Herzegovina',
        'official': 'Bosnia and Herzegovina',
        'native': {
          'bos': {
            'official': 'Bosna i Hercegovina',
            'common': 'Bosna i Hercegovina'
          },
          'hrv': {
            'official': 'Bosna i Hercegovina',
            'common': 'Bosna i Hercegovina'
          },
          'srp': {
            'official': '\u0411\u043e\u0441\u043da \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043e\u0432\u0438\u043d\u0430',
            'common': '\u0411\u043e\u0441\u043da \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043e\u0432\u0438\u043d\u0430'
          }
        }
      },
      'tld': [
        '.ba'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\udde7\ud83c\udde6'

    },
    {
      'name': {
        'common': 'Saint Barth\u00e9lemy',
        'official': 'Collectivity of Saint Barth\u00e9lemy',
        'native': {
          'fra': {
            'official': 'Collectivit\u00e9 de Saint-Barth\u00e9lemy',
            'common': 'Saint-Barth\u00e9lemy'
          }
        }
      },
      'tld': [
        '.bl'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde7\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'Saint Helena, Ascension and Tristan da Cunha',
        'official': 'Saint Helena, Ascension and Tristan da Cunha',
        'native': {
          'eng': {
            'official': 'Saint Helena, Ascension and Tristan da Cunha',
            'common': 'Saint Helena, Ascension and Tristan da Cunha'
          }
        }
      },
      'tld': [
        '.sh',
        '.ac'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf8\ud83c\udded'

    },
    {
      'name': {
        'common': 'Belarus',
        'official': 'Republic of Belarus',
        'native': {
          'bel': {
            'official': '\u0420\u044d\u0441\u043f\u0443\u0431\u043b\u0456\u043a\u0430 \u0411\u0435\u043b\u0430\u0440\u0443\u0441\u044c',
            'common': '\u0411\u0435\u043b\u0430\u0440\u0443\u0301\u0441\u044c'
          },
          'rus': {
            'official': '\u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u0411\u0435\u043b\u0430\u0440\u0443\u0441\u044c',
            'common': '\u0411\u0435\u043b\u0430\u0440\u0443\u0441\u044c'
          }
        }
      },
      'tld': [
        '.by'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\udde7\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'Belize',
        'official': 'Belize',
        'native': {
          'bjz': {
            'official': 'Belize',
            'common': 'Belize'
          },
          'eng': {
            'official': 'Belize',
            'common': 'Belize'
          },
          'spa': {
            'official': 'Belice',
            'common': 'Belice'
          }
        }
      },
      'tld': [
        '.bz'
      ],
      'region': 'Americas',
      'subregion': 'Central America',
      'flag': '\ud83c\udde7\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Bermuda',
        'official': 'Bermuda',
        'native': {
          'eng': {
            'official': 'Bermuda',
            'common': 'Bermuda'
          }
        }
      },
      'tld': [
        '.bm'
      ],
      'region': 'Americas',
      'subregion': 'North America',
      'flag': '\ud83c\udde7\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Bolivia',
        'official': 'Plurinational State of Bolivia',
        'native': {
          'aym': {
            'official': 'Wuliwya Suyu',
            'common': 'Wuliwya'
          },
          'grn': {
            'official': 'Tet\u00e3 Vol\u00edvia',
            'common': 'Vol\u00edvia'
          },
          'que': {
            'official': 'Buliwya Mamallaqta',
            'common': 'Buliwya'
          },
          'spa': {
            'official': 'Estado Plurinacional de Bolivia',
            'common': 'Bolivia'
          }
        }
      },
      'tld': [
        '.bo'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\udde7\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Caribbean Netherlands',
        'official': 'Bonaire, Sint Eustatius and Saba',
        'native': {
          'nld': {
            'official': 'Bonaire, Sint Eustatius en Saba',
            'common': 'Caribisch Nederland'
          },
          'pap': {
            'official': 'Boneiru, Sint Eustatius y Saba',
            'common': 'Boneiru, Sint Eustatius y Saba'
          }
        }
      },
      'tld': [
        '.bq',
        '.nl'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': ''

    },
    {
      'name': {
        'common': 'Brazil',
        'official': 'Federative Republic of Brazil',
        'native': {
          'por': {
            'official': 'Rep\u00fablica Federativa do Brasil',
            'common': 'Brasil'
          }
        }
      },
      'tld': [
        '.br'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\udde7\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Barbados',
        'official': 'Barbados',
        'native': {
          'eng': {
            'official': 'Barbados',
            'common': 'Barbados'
          }
        }
      },
      'tld': [
        '.bb'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde7\ud83c\udde7'

    },
    {
      'name': {
        'common': 'Brunei',
        'official': 'Nation of Brunei, Abode of Peace',
        'native': {
          'msa': {
            'official': 'Nation of Brunei, Abode Damai',
            'common': 'Negara Brunei Darussalam'
          }
        }
      },
      'tld': [
        '.bn'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\udde7\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Bhutan',
        'official': 'Kingdom of Bhutan',
        'native': {
          'dzo': {
            'official': '\u0f60\u0f56\u0fb2\u0f74\u0f42\u0f0b\u0f62\u0f92\u0fb1\u0f63\u0f0b\u0f41\u0f56\u0f0b',
            'common': '\u0f60\u0f56\u0fb2\u0f74\u0f42\u0f0b\u0f61\u0f74\u0f63\u0f0b'
          }
        }
      },
      'tld': [
        '.bt'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\udde7\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Bouvet Island',
        'official': 'Bouvet Island',
        'native': {
          'nor': {
            'official': 'Bouvet\u00f8ya',
            'common': 'Bouvet\u00f8ya'
          }
        }
      },
      'tld': [
        '.bv'
      ],
      'region': 'Antarctic',
      'subregion': '',
      'flag': '\ud83c\udde7\ud83c\uddfb'

    },
    {
      'name': {
        'common': 'Botswana',
        'official': 'Republic of Botswana',
        'native': {
          'eng': {
            'official': 'Republic of Botswana',
            'common': 'Botswana'
          },
          'tsn': {
            'official': 'Lefatshe la Botswana',
            'common': 'Botswana'
          }
        }
      },
      'tld': [
        '.bw'
      ],
      'region': 'Africa',
      'subregion': 'Southern Africa',
      'flag': '\ud83c\udde7\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Central African Republic',
        'official': 'Central African Republic',
        'native': {
          'fra': {
            'official': 'R\u00e9publique centrafricaine',
            'common': 'R\u00e9publique centrafricaine'
          },
          'sag': {
            'official': 'K\u00f6d\u00f6r\u00f6s\u00ease t\u00ee B\u00eaafr\u00eeka',
            'common': 'B\u00eaafr\u00eeka'
          }
        }
      },
      'tld': [
        '.cf'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\udde8\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Canada',
        'official': 'Canada',
        'native': {
          'eng': {
            'official': 'Canada',
            'common': 'Canada'
          },
          'fra': {
            'official': 'Canada',
            'common': 'Canada'
          }
        }
      },
      'tld': [
        '.ca'
      ],
      'region': 'Americas',
      'subregion': 'North America',
      'flag': '\ud83c\udde8\ud83c\udde6'

    },
    {
      'name': {
        'common': 'Cocos (Keeling) Islands',
        'official': 'Territory of the Cocos (Keeling) Islands',
        'native': {
          'eng': {
            'official': 'Territory of the Cocos (Keeling) Islands',
            'common': 'Cocos (Keeling) Islands'
          }
        }
      },
      'tld': [
        '.cc'
      ],
      'region': 'Oceania',
      'subregion': 'Australia and New Zealand',
      'flag': '\ud83c\udde8\ud83c\udde8'

    },
    {
      'name': {
        'common': 'Switzerland',
        'official': 'Swiss Confederation',
        'native': {
          'fra': {
            'official': 'Conf\u00e9d\u00e9ration suisse',
            'common': 'Suisse'
          },
          'gsw': {
            'official': 'Schweizerische Eidgenossenschaft',
            'common': 'Schweiz'
          },
          'ita': {
            'official': 'Confederazione Svizzera',
            'common': 'Svizzera'
          },
          'roh': {
            'official': 'Confederaziun svizra',
            'common': 'Svizra'
          }
        }
      },
      'tld': [
        '.ch'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\udde8\ud83c\udded'

    },
    {
      'name': {
        'common': 'Chile',
        'official': 'Republic of Chile',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de Chile',
            'common': 'Chile'
          }
        }
      },
      'tld': [
        '.cl'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\udde8\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'China',
        'official': "People's Republic of China",
        'native': {
          'zho': {
            'official': '\u4e2d\u534e\u4eba\u6c11\u5171\u548c\u56fd',
            'common': '\u4e2d\u56fd'
          }
        }
      },
      'tld': [
        '.cn',
        '.\u4e2d\u56fd',
        '.\u4e2d\u570b',
        '.\u516c\u53f8',
        '.\u7f51\u7edc'
      ],
      'region': 'Asia',
      'subregion': 'Eastern Asia',
      'flag': '\ud83c\udde8\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Ivory Coast',
        'official': "Republic of C\u00f4te d'Ivoire",
        'native': {
          'fra': {
            'official': "R\u00e9publique de C\u00f4te d'Ivoire",
            'common': "C\u00f4te d'Ivoire"
          }
        }
      },
      'tld': [
        '.ci'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\udde8\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Cameroon',
        'official': 'Republic of Cameroon',
        'native': {
          'eng': {
            'official': 'Republic of Cameroon',
            'common': 'Cameroon'
          },
          'fra': {
            'official': 'R\u00e9publique du Cameroun',
            'common': 'Cameroun'
          }
        }
      },
      'tld': [
        '.cm'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\udde8\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'DR Congo',
        'official': 'Democratic Republic of the Congo',
        'native': {
          'fra': {
            'official': 'R\u00e9publique d\u00e9mocratique du Congo',
            'common': 'RD Congo'
          },
          'kon': {
            'official': 'Repubilika ya Kongo Demokratiki',
            'common': 'Repubilika ya Kongo Demokratiki'
          },
          'lin': {
            'official': 'Republiki ya Kong\u00f3 Demokratiki',
            'common': 'Republiki ya Kong\u00f3 Demokratiki'
          },
          'lua': {
            'official': 'Ditunga dia Kongu wa Mungalaata',
            'common': 'Ditunga dia Kongu wa Mungalaata'
          },
          'swa': {
            'official': 'Jamhuri ya Kidemokrasia ya Kongo',
            'common': 'Jamhuri ya Kidemokrasia ya Kongo'
          }
        }
      },
      'tld': [
        '.cd'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\udde8\ud83c\udde9'

    },
    {
      'name': {
        'common': 'Republic of the Congo',
        'official': 'Republic of the Congo',
        'native': {
          'fra': {
            'official': 'R\u00e9publique du Congo',
            'common': 'R\u00e9publique du Congo'
          },
          'kon': {
            'official': 'Repubilika ya Kongo',
            'common': 'Repubilika ya Kongo'
          },
          'lin': {
            'official': 'Republ\u00edki ya Kong\u00f3',
            'common': 'Republ\u00edki ya Kong\u00f3'
          }
        }
      },
      'tld': [
        '.cg'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\udde8\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Cook Islands',
        'official': 'Cook Islands',
        'native': {
          'eng': {
            'official': 'Cook Islands',
            'common': 'Cook Islands'
          },
          'rar': {
            'official': "K\u016bki '\u0100irani",
            'common': "K\u016bki '\u0100irani"
          }
        }
      },
      'tld': [
        '.ck'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\udde8\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Colombia',
        'official': 'Republic of Colombia',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de Colombia',
            'common': 'Colombia'
          }
        }
      },
      'tld': [
        '.co'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\udde8\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Comoros',
        'official': 'Union of the Comoros',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u0627\u062a\u062d\u0627\u062f \u0627\u0644\u0642\u0645\u0631\u064a',
            'common': '\u0627\u0644\u0642\u0645\u0631\u200e'
          },
          'fra': {
            'official': 'Union des Comores',
            'common': 'Comores'
          },
          'zdj': {
            'official': 'Udzima wa Komori',
            'common': 'Komori'
          }
        }
      },
      'tld': [
        '.km'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf0\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Cape Verde',
        'official': 'Republic of Cabo Verde',
        'native': {
          'por': {
            'official': 'Rep\u00fablica de Cabo Verde',
            'common': 'Cabo Verde'
          }
        }
      },
      'tld': [
        '.cv'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\udde8\ud83c\uddfb'

    },
    {
      'name': {
        'common': 'Costa Rica',
        'official': 'Republic of Costa Rica',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de Costa Rica',
            'common': 'Costa Rica'
          }
        }
      },
      'tld': [
        '.cr'
      ],
      'region': 'Americas',
      'subregion': 'Central America',
      'flag': '\ud83c\udde8\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Cuba',
        'official': 'Republic of Cuba',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de Cuba',
            'common': 'Cuba'
          }
        }
      },
      'tld': [
        '.cu'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde8\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Cura\u00e7ao',
        'official': 'Country of Cura\u00e7ao',
        'native': {
          'eng': {
            'official': 'Country of Cura\u00e7ao',
            'common': 'Cura\u00e7ao'
          },
          'nld': {
            'official': 'Land Cura\u00e7ao',
            'common': 'Cura\u00e7ao'
          },
          'pap': {
            'official': 'Pais K\u00f2rsou',
            'common': 'Pais K\u00f2rsou'
          }
        }
      },
      'tld': [
        '.cw'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde8\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Christmas Island',
        'official': 'Territory of Christmas Island',
        'native': {
          'eng': {
            'official': 'Territory of Christmas Island',
            'common': 'Christmas Island'
          }
        }
      },
      'tld': [
        '.cx'
      ],
      'region': 'Oceania',
      'subregion': 'Australia and New Zealand',
      'flag': '\ud83c\udde8\ud83c\uddfd'

    },
    {
      'name': {
        'common': 'Cayman Islands',
        'official': 'Cayman Islands',
        'native': {
          'eng': {
            'official': 'Cayman Islands',
            'common': 'Cayman Islands'
          }
        }
      },
      'tld': [
        '.ky'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf0\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'Cyprus',
        'official': 'Republic of Cyprus',
        'native': {
          'ell': {
            'official': '\u0394\u03b7\u03bc\u03bf\u03ba\u03c1\u03b1\u03c4\u03af\u03b1 \u03c4\u03b7\u03c2 \u039a\u03cd\u03c0\u03c1\u03bf\u03c2',
            'common': '\u039a\u03cd\u03c0\u03c1\u03bf\u03c2'
          },
          'tur': {
            'official': 'K\u0131br\u0131s Cumhuriyeti',
            'common': 'K\u0131br\u0131s'
          }
        }
      },
      'tld': [
        '.cy'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\udde8\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'Czechia',
        'official': 'Czech Republic',
        'native': {
          'ces': {
            'official': '\u010desk\u00e1 republika',
            'common': '\u010cesko'
          },
          'slk': {
            'official': '\u010cesk\u00e1 republika',
            'common': '\u010cesko'
          }
        }
      },
      'tld': [
        '.cz'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\udde8\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Germany',
        'official': 'Federal Republic of Germany',
        'native': {
          'deu': {
            'official': 'Bundesrepublik Deutschland',
            'common': 'Deutschland'
          }
        }
      },
      'tld': [
        '.de'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\udde9\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Djibouti',
        'official': 'Republic of Djibouti',
        'native': {
          'ara': {
            'official': '\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u062c\u064a\u0628\u0648\u062a\u064a',
            'common': '\u062c\u064a\u0628\u0648\u062a\u064a\u200e'
          },
          'fra': {
            'official': 'R\u00e9publique de Djibouti',
            'common': 'Djibouti'
          }
        }
      },
      'tld': [
        '.dj'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\udde9\ud83c\uddef'

    },
    {
      'name': {
        'common': 'Dominica',
        'official': 'Commonwealth of Dominica',
        'native': {
          'eng': {
            'official': 'Commonwealth of Dominica',
            'common': 'Dominica'
          }
        }
      },
      'tld': [
        '.dm'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde9\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Denmark',
        'official': 'Kingdom of Denmark',
        'native': {
          'dan': {
            'official': 'Kongeriget Danmark',
            'common': 'Danmark'
          }
        }
      },
      'tld': [
        '.dk'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\udde9\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Dominican Republic',
        'official': 'Dominican Republic',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica Dominicana',
            'common': 'Rep\u00fablica Dominicana'
          }
        }
      },
      'tld': [
        '.do'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udde9\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Algeria',
        'official': "People's Democratic Republic of Algeria",
        'native': {
          'ara': {
            'official': '\u0627\u0644\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u062f\u064a\u0645\u0642\u0631\u0627\u0637\u064a\u0629 \u0627\u0644\u0634\u0639\u0628\u064a\u0629 \u0627\u0644\u062c\u0632\u0627\u0626\u0631\u064a\u0629',
            'common': '\u0627\u0644\u062c\u0632\u0627\u0626\u0631'
          }
        }
      },
      'tld': [
        '.dz',
        '\u0627\u0644\u062c\u0632\u0627\u0626\u0631.'
      ],
      'region': 'Africa',
      'subregion': 'Northern Africa',
      'flag': '\ud83c\udde9\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Ecuador',
        'official': 'Republic of Ecuador',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica del Ecuador',
            'common': 'Ecuador'
          }
        }
      },
      'tld': [
        '.ec'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddea\ud83c\udde8'

    },
    {
      'name': {
        'common': 'Egypt',
        'official': 'Arab Republic of Egypt',
        'native': {
          'ara': {
            'official': '\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0645\u0635\u0631 \u0627\u0644\u0639\u0631\u0628\u064a\u0629',
            'common': '\u0645\u0635\u0631'
          }
        }
      },
      'tld': [
        '.eg',
        '.\u0645\u0635\u0631'
      ],
      'region': 'Africa',
      'subregion': 'Northern Africa',
      'flag': '\ud83c\uddea\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Eritrea',
        'official': 'State of Eritrea',
        'native': {
          'ara': {
            'official': '\u062f\u0648\u0644\u0629 \u0625\u0631\u062a\u0631\u064a\u0627',
            'common': '\u0625\u0631\u062a\u0631\u064a\u0627\u200e'
          },
          'eng': {
            'official': 'State of Eritrea',
            'common': 'Eritrea'
          },
          'tir': {
            'official': '\u1203\u1308\u1228 \u12a4\u122d\u1275\u122b',
            'common': '\u12a4\u122d\u1275\u122b'
          }
        }
      },
      'tld': [
        '.er'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddea\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Western Sahara',
        'official': 'Sahrawi Arab Democratic Republic',
        'native': {
          'ber': {
            'official': 'Sahrawi Arab Democratic Republic',
            'common': 'Western Sahara'
          },
          'mey': {
            'official': '\u0627\u0644\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u0639\u0631\u0628\u064a\u0629 \u0627\u0644\u0635\u062d\u0631\u0627\u0648\u064a\u0629 \u0627\u0644\u062f\u064a\u0645\u0642\u0631\u0627\u0637\u064a\u0629',
            'common': '\u0627\u0644\u0635\u062d\u0631\u0627\u0621 \u0627\u0644\u063a\u0631\u0628\u064a\u0629'
          },
          'spa': {
            'official': 'Rep\u00fablica \u00c1rabe Saharaui Democr\u00e1tica',
            'common': 'Sahara Occidental'
          }
        }
      },
      'tld': [
        '.eh'
      ],
      'region': 'Africa',
      'subregion': 'Northern Africa',
      'flag': '\ud83c\uddea\ud83c\udded'

    },
    {
      'name': {
        'common': 'Spain',
        'official': 'Kingdom of Spain',
        'native': {
          'spa': {
            'official': 'Reino de Espa\u00f1a',
            'common': 'Espa\u00f1a'
          }
        }
      },
      'tld': [
        '.es'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddea\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Estonia',
        'official': 'Republic of Estonia',
        'native': {
          'est': {
            'official': 'Eesti Vabariik',
            'common': 'Eesti'
          }
        }
      },
      'tld': [
        '.ee'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddea\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Ethiopia',
        'official': 'Federal Democratic Republic of Ethiopia',
        'native': {
          'amh': {
            'official': '\u12e8\u12a2\u1275\u12ee\u1335\u12eb \u134c\u12f4\u122b\u120b\u12ca \u12f2\u121e\u12ad\u122b\u1232\u12eb\u12ca \u122a\u1350\u1265\u120a\u12ad',
            'common': '\u12a2\u1275\u12ee\u1335\u12eb'
          }
        }
      },
      'tld': [
        '.et'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddea\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Finland',
        'official': 'Republic of Finland',
        'native': {
          'fin': {
            'official': 'Suomen tasavalta',
            'common': 'Suomi'
          },
          'swe': {
            'official': 'Republiken Finland',
            'common': 'Finland'
          }
        }
      },
      'tld': [
        '.fi'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddeb\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Fiji',
        'official': 'Republic of Fiji',
        'native': {
          'eng': {
            'official': 'Republic of Fiji',
            'common': 'Fiji'
          },
          'fij': {
            'official': 'Matanitu Tugalala o Viti',
            'common': 'Viti'
          },
          'hif': {
            'official': '\u0930\u093f\u092a\u092c\u094d\u0932\u093f\u0915 \u0911\u092b \u092b\u0940\u091c\u0940',
            'common': '\u092b\u093f\u091c\u0940'
          }
        }
      },
      'tld': [
        '.fj'
      ],
      'region': 'Oceania',
      'subregion': 'Melanesia',
      'flag': '\ud83c\uddeb\ud83c\uddef'

    },
    {
      'name': {
        'common': 'Falkland Islands',
        'official': 'Falkland Islands',
        'native': {
          'eng': {
            'official': 'Falkland Islands',
            'common': 'Falkland Islands'
          }
        }
      },
      'tld': [
        '.fk'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddeb\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'France',
        'official': 'French Republic',
        'native': {
          'fra': {
            'official': 'R\u00e9publique fran\u00e7aise',
            'common': 'France'
          }
        }
      },
      'tld': [
        '.fr'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\uddeb\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Faroe Islands',
        'official': 'Faroe Islands',
        'native': {
          'dan': {
            'official': 'F\u00e6r\u00f8erne',
            'common': 'F\u00e6r\u00f8erne'
          },
          'fao': {
            'official': 'F\u00f8royar',
            'common': 'F\u00f8royar'
          }
        }
      },
      'tld': [
        '.fo'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddeb\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Micronesia',
        'official': 'Federated States of Micronesia',
        'native': {
          'eng': {
            'official': 'Federated States of Micronesia',
            'common': 'Micronesia'
          }
        }
      },
      'tld': [
        '.fm'
      ],
      'region': 'Oceania',
      'subregion': 'Micronesia',
      'flag': '\ud83c\uddeb\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Gabon',
        'official': 'Gabonese Republic',
        'native': {
          'fra': {
            'official': 'R\u00e9publique gabonaise',
            'common': 'Gabon'
          }
        }
      },
      'tld': [
        '.ga'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\uddec\ud83c\udde6'

    },
    {
      'name': {
        'common': 'United Kingdom',
        'official': 'United Kingdom of Great Britain and Northern Ireland',
        'native': {
          'eng': {
            'official': 'United Kingdom of Great Britain and Northern Ireland',
            'common': 'United Kingdom'
          }
        }
      },
      'tld': [
        '.uk'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddec\ud83c\udde7'

    },
    {
      'name': {
        'common': 'Georgia',
        'official': 'Georgia',
        'native': {
          'kat': {
            'official': '\u10e1\u10d0\u10e5\u10d0\u10e0\u10d7\u10d5\u10d4\u10da\u10dd',
            'common': '\u10e1\u10d0\u10e5\u10d0\u10e0\u10d7\u10d5\u10d4\u10da\u10dd'
          }
        }
      },
      'tld': [
        '.ge'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddec\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Guernsey',
        'official': 'Bailiwick of Guernsey',
        'native': {
          'eng': {
            'official': 'Bailiwick of Guernsey',
            'common': 'Guernsey'
          },
          'fra': {
            'official': 'Bailliage de Guernesey',
            'common': 'Guernesey'
          },
          'nfr': {
            'official': 'Dg\u00e8rn\u00e9siais',
            'common': 'Dg\u00e8rn\u00e9siais'
          }
        }
      },
      'tld': [
        '.gg'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddec\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Ghana',
        'official': 'Republic of Ghana',
        'native': {
          'eng': {
            'official': 'Republic of Ghana',
            'common': 'Ghana'
          }
        }
      },
      'tld': [
        '.gh'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddec\ud83c\udded'

    },
    {
      'name': {
        'common': 'Gibraltar',
        'official': 'Gibraltar',
        'native': {
          'eng': {
            'official': 'Gibraltar',
            'common': 'Gibraltar'
          }
        }
      },
      'tld': [
        '.gi'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddec\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Guinea',
        'official': 'Republic of Guinea',
        'native': {
          'fra': {
            'official': 'R\u00e9publique de Guin\u00e9e',
            'common': 'Guin\u00e9e'
          }
        }
      },
      'tld': [
        '.gn'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddec\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Guadeloupe',
        'official': 'Guadeloupe',
        'native': {
          'fra': {
            'official': 'Guadeloupe',
            'common': 'Guadeloupe'
          }
        }
      },
      'tld': [
        '.gp'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddec\ud83c\uddf5'

    },
    {
      'name': {
        'common': 'Gambia',
        'official': 'Republic of the Gambia',
        'native': {
          'eng': {
            'official': 'Republic of the Gambia',
            'common': 'Gambia'
          }
        }
      },
      'tld': [
        '.gm'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddec\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Guinea-Bissau',
        'official': 'Republic of Guinea-Bissau',
        'native': {
          'por': {
            'official': 'Rep\u00fablica da Guin\u00e9-Bissau',
            'common': 'Guin\u00e9-Bissau'
          },
          'pov': {
            'official': 'Rep\u00fablica da Guin\u00e9-Bissau',
            'common': 'Guin\u00e9-Bissau'
          }
        }
      },
      'tld': [
        '.gw'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddec\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Equatorial Guinea',
        'official': 'Republic of Equatorial Guinea',
        'native': {
          'fra': {
            'official': 'R\u00e9publique de la Guin\u00e9e \u00c9quatoriale',
            'common': 'Guin\u00e9e \u00e9quatoriale'
          },
          'por': {
            'official': 'Rep\u00fablica da Guin\u00e9 Equatorial',
            'common': 'Guin\u00e9 Equatorial'
          },
          'spa': {
            'official': 'Rep\u00fablica de Guinea Ecuatorial',
            'common': 'Guinea Ecuatorial'
          }
        }
      },
      'tld': [
        '.gq'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\uddec\ud83c\uddf6'

    },
    {
      'name': {
        'common': 'Greece',
        'official': 'Hellenic Republic',
        'native': {
          'ell': {
            'official': '\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ae \u0394\u03b7\u03bc\u03bf\u03ba\u03c1\u03b1\u03c4\u03af\u03b1',
            'common': '\u0395\u03bb\u03bb\u03ac\u03b4\u03b1'
          }
        }
      },
      'tld': [
        '.gr'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddec\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Grenada',
        'official': 'Grenada',
        'native': {
          'eng': {
            'official': 'Grenada',
            'common': 'Grenada'
          }
        }
      },
      'tld': [
        '.gd'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddec\ud83c\udde9'

    },
    {
      'name': {
        'common': 'Greenland',
        'official': 'Greenland',
        'native': {
          'kal': {
            'official': 'Kalaallit Nunaat',
            'common': 'Kalaallit Nunaat'
          }
        }
      },
      'tld': [
        '.gl'
      ],
      'region': 'Americas',
      'subregion': 'North America',
      'flag': '\ud83c\uddec\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'Guatemala',
        'official': 'Republic of Guatemala',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de Guatemala',
            'common': 'Guatemala'
          }
        }
      },
      'tld': [
        '.gt'
      ],
      'region': 'Americas',
      'subregion': 'Central America',
      'flag': '\ud83c\uddec\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'French Guiana',
        'official': 'Guiana',
        'native': {
          'fra': {
            'official': 'Guyane',
            'common': 'Guyane fran\u00e7aise'
          }
        }
      },
      'tld': [
        '.gf'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddec\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Guam',
        'official': 'Guam',
        'native': {
          'cha': {
            'official': 'Gu\u00e5h\u00e5n',
            'common': 'Gu\u00e5h\u00e5n'
          },
          'eng': {
            'official': 'Guam',
            'common': 'Guam'
          },
          'spa': {
            'official': 'Guam',
            'common': 'Guam'
          }
        }
      },
      'tld': [
        '.gu'
      ],
      'region': 'Oceania',
      'subregion': 'Micronesia',
      'flag': '\ud83c\uddec\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Guyana',
        'official': 'Co-operative Republic of Guyana',
        'native': {
          'eng': {
            'official': 'Co-operative Republic of Guyana',
            'common': 'Guyana'
          }
        }
      },
      'tld': [
        '.gy'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddec\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'Hong Kong',
        'official': "Hong Kong Special Administrative Region of the People's Republic of China",
        'native': {
          'eng': {
            'official': "Hong Kong Special Administrative Region of the People's Republic of China",
            'common': 'Hong Kong'
          },
          'zho': {
            'official': '\u4e2d\u534e\u4eba\u6c11\u5171\u548c\u56fd\u9999\u6e2f\u7279\u522b\u884c\u653f\u533a',
            'common': '\u9999\u6e2f'
          }
        }
      },
      'tld': [
        '.hk',
        '.\u9999\u6e2f'
      ],
      'region': 'Asia',
      'subregion': 'Eastern Asia',
      'flag': '\ud83c\udded\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Heard Island and McDonald Islands',
        'official': 'Heard Island and McDonald Islands',
        'native': {
          'eng': {
            'official': 'Heard Island and McDonald Islands',
            'common': 'Heard Island and McDonald Islands'
          }
        }
      },
      'tld': [
        '.hm',
        '.aq'
      ],
      'region': 'Antarctic',
      'subregion': '',
      'flag': '\ud83c\udded\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Honduras',
        'official': 'Republic of Honduras',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de Honduras',
            'common': 'Honduras'
          }
        }
      },
      'tld': [
        '.hn'
      ],
      'region': 'Americas',
      'subregion': 'Central America',
      'flag': '\ud83c\udded\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Croatia',
        'official': 'Republic of Croatia',
        'native': {
          'hrv': {
            'official': 'Republika Hrvatska',
            'common': 'Hrvatska'
          }
        }
      },
      'tld': [
        '.hr'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\udded\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Haiti',
        'official': 'Republic of Haiti',
        'native': {
          'fra': {
            'official': "R\u00e9publique d'Ha\u00efti",
            'common': 'Ha\u00efti'
          },
          'hat': {
            'official': 'Repiblik Ayiti',
            'common': 'Ayiti'
          }
        }
      },
      'tld': [
        '.ht'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\udded\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Hungary',
        'official': 'Hungary',
        'native': {
          'hun': {
            'official': 'Magyarorsz\u00e1g',
            'common': 'Magyarorsz\u00e1g'
          }
        }
      },
      'tld': [
        '.hu'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\udded\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Indonesia',
        'official': 'Republic of Indonesia',
        'native': {
          'ind': {
            'official': 'Republik Indonesia',
            'common': 'Indonesia'
          }
        }
      },
      'tld': [
        '.id'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddee\ud83c\udde9'

    },
    {
      'name': {
        'common': 'Isle of Man',
        'official': 'Isle of Man',
        'native': {
          'eng': {
            'official': 'Isle of Man',
            'common': 'Isle of Man'
          },
          'glv': {
            'official': 'Ellan Vannin or Mannin',
            'common': 'Mannin'
          }
        }
      },
      'tld': [
        '.im'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddee\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'India',
        'official': 'Republic of India',
        'native': {
          'eng': {
            'official': 'Republic of India',
            'common': 'India'
          },
          'hin': {
            'official': '\u092d\u093e\u0930\u0924 \u0917\u0923\u0930\u093e\u091c\u094d\u092f',
            'common': '\u092d\u093e\u0930\u0924'
          },
          'tam': {
            'official': '\u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0baf\u0b95\u0bcd \u0b95\u0bc1\u0b9f\u0bbf\u0baf\u0bb0\u0b9a\u0bc1',
            'common': '\u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0baf\u0bbe'
          }
        }
      },
      'tld': [
        '.in'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\uddee\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'British Indian Ocean Territory',
        'official': 'British Indian Ocean Territory',
        'native': {
          'eng': {
            'official': 'British Indian Ocean Territory',
            'common': 'British Indian Ocean Territory'
          }
        }
      },
      'tld': [
        '.io'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddee\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Ireland',
        'official': 'Republic of Ireland',
        'native': {
          'eng': {
            'official': 'Republic of Ireland',
            'common': 'Ireland'
          },
          'gle': {
            'official': 'Poblacht na h\u00c9ireann',
            'common': '\u00c9ire'
          }
        }
      },
      'tld': [
        '.ie'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddee\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Iran',
        'official': 'Islamic Republic of Iran',
        'native': {
          'fas': {
            'official': '\u062c\u0645\u0647\u0648\u0631\u06cc \u0627\u0633\u0644\u0627\u0645\u06cc \u0627\u06cc\u0631\u0627\u0646',
            'common': '\u0627\u06cc\u0631\u0627\u0646'
          }
        }
      },
      'tld': [
        '.ir',
        '\u0627\u06cc\u0631\u0627\u0646.'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\uddee\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Iraq',
        'official': 'Republic of Iraq',
        'native': {
          'ara': {
            'official': '\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u0639\u0631\u0627\u0642',
            'common': '\u0627\u0644\u0639\u0631\u0627\u0642'
          },
          'arc': {
            'official': '\u0729\u0718\u073c\u071b\u0722\u0735\u0710 \u0710\u071d\u073c\u072a\u0732\u0729',
            'common': '\u0729\u0718\u073c\u071b\u0722\u0735\u0710'
          },
          'ckb': {
            'official': '\u06a9\u06c6\u0645\u0627\u0631\u06cc \u0639\u06ce\u0631\u0627\u0642',
            'common': '\u06a9\u06c6\u0645\u0627\u0631\u06cc'
          }
        }
      },
      'tld': [
        '.iq'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddee\ud83c\uddf6'

    },
    {
      'name': {
        'common': 'Iceland',
        'official': 'Iceland',
        'native': {
          'isl': {
            'official': '\u00cdsland',
            'common': '\u00cdsland'
          }
        }
      },
      'tld': [
        '.is'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddee\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Israel',
        'official': 'State of Israel',
        'native': {
          'ara': {
            'official': '\u062f\u0648\u0644\u0629 \u0625\u0633\u0631\u0627\u0626\u064a\u0644',
            'common': '\u0625\u0633\u0631\u0627\u0626\u064a\u0644'
          },
          'heb': {
            'official': '\u05de\u05d3\u05d9\u05e0\u05ea \u05d9\u05e9\u05e8\u05d0\u05dc',
            'common': '\u05d9\u05e9\u05e8\u05d0\u05dc'
          }
        }
      },
      'tld': [
        '.il'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddee\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'Italy',
        'official': 'Italian Republic',
        'native': {
          'ita': {
            'official': 'Repubblica italiana',
            'common': 'Italia'
          }
        }
      },
      'tld': [
        '.it'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddee\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Jamaica',
        'official': 'Jamaica',
        'native': {
          'eng': {
            'official': 'Jamaica',
            'common': 'Jamaica'
          },
          'jam': {
            'official': 'Jamaica',
            'common': 'Jamaica'
          }
        }
      },
      'tld': [
        '.jm'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddef\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Jersey',
        'official': 'Bailiwick of Jersey',
        'native': {
          'eng': {
            'official': 'Bailiwick of Jersey',
            'common': 'Jersey'
          },
          'fra': {
            'official': 'Bailliage de Jersey',
            'common': 'Jersey'
          },
          'nrf': {
            'official': 'Bailliage d\u00e9 J\u00e8rri',
            'common': 'J\u00e8rri'
          }
        }
      },
      'tld': [
        '.je'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddef\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Jordan',
        'official': 'Hashemite Kingdom of Jordan',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0623\u0631\u062f\u0646\u064a\u0629 \u0627\u0644\u0647\u0627\u0634\u0645\u064a\u0629',
            'common': '\u0627\u0644\u0623\u0631\u062f\u0646'
          }
        }
      },
      'tld': [
        '.jo',
        '\u0627\u0644\u0627\u0631\u062f\u0646.'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddef\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Japan',
        'official': 'Japan',
        'native': {
          'jpn': {
            'official': '\u65e5\u672c',
            'common': '\u65e5\u672c'
          }
        }
      },
      'tld': [
        '.jp',
        '.\u307f\u3093\u306a'
      ],
      'region': 'Asia',
      'subregion': 'Eastern Asia',
      'flag': '\ud83c\uddef\ud83c\uddf5'

    },
    {
      'name': {
        'common': 'Kazakhstan',
        'official': 'Republic of Kazakhstan',
        'native': {
          'kaz': {
            'official': '\u049a\u0430\u0437\u0430\u049b\u0441\u0442\u0430\u043d \u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430\u0441\u044b',
            'common': '\u049a\u0430\u0437\u0430\u049b\u0441\u0442\u0430\u043d'
          },
          'rus': {
            'official': '\u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u041a\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043d',
            'common': '\u041a\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043d'
          }
        }
      },
      'tld': [
        '.kz',
        '.\u049b\u0430\u0437'
      ],
      'region': 'Asia',
      'subregion': 'Central Asia',
      'flag': '\ud83c\uddf0\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Kenya',
        'official': 'Republic of Kenya',
        'native': {
          'eng': {
            'official': 'Republic of Kenya',
            'common': 'Kenya'
          },
          'swa': {
            'official': 'Republic of Kenya',
            'common': 'Kenya'
          }
        }
      },
      'tld': [
        '.ke'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf0\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Kyrgyzstan',
        'official': 'Kyrgyz Republic',
        'native': {
          'kir': {
            'official': '\u041a\u044b\u0440\u0433\u044b\u0437 \u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430\u0441\u044b',
            'common': '\u041a\u044b\u0440\u0433\u044b\u0437\u0441\u0442\u0430\u043d'
          },
          'rus': {
            'official': '\u041a\u044b\u0440\u0433\u044b\u0437\u0441\u043a\u0430\u044f \u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430',
            'common': '\u041a\u0438\u0440\u0433\u0438\u0437\u0438\u044f'
          }
        }
      },
      'tld': [
        '.kg'
      ],
      'region': 'Asia',
      'subregion': 'Central Asia',
      'flag': '\ud83c\uddf0\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Cambodia',
        'official': 'Kingdom of Cambodia',
        'native': {
          'khm': {
            'official': '\u1796\u17d2\u179a\u17c7\u179a\u17b6\u1787\u17b6\u178e\u17b6\u1785\u1780\u17d2\u179a\u1780\u1798\u17d2\u1796\u17bb\u1787\u17b6',
            'common': 'K\u00e2mp\u016dch\u00e9a'
          }
        }
      },
      'tld': [
        '.kh'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddf0\ud83c\udded'

    },
    {
      'name': {
        'common': 'Kiribati',
        'official': 'Independent and Sovereign Republic of Kiribati',
        'native': {
          'eng': {
            'official': 'Independent and Sovereign Republic of Kiribati',
            'common': 'Kiribati'
          },
          'gil': {
            'official': 'Ribaberiki Kiribati',
            'common': 'Kiribati'
          }
        }
      },
      'tld': [
        '.ki'
      ],
      'region': 'Oceania',
      'subregion': 'Micronesia',
      'flag': '\ud83c\uddf0\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Saint Kitts and Nevis',
        'official': 'Federation of Saint Christopher and Nevis',
        'native': {
          'eng': {
            'official': 'Federation of Saint Christopher and Nevis',
            'common': 'Saint Kitts and Nevis'
          }
        }
      },
      'tld': [
        '.kn'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf0\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'South Korea',
        'official': 'Republic of Korea',
        'native': {
          'kor': {
            'official': '\ub300\ud55c\ubbfc\uad6d',
            'common': '\ud55c\uad6d'
          }
        }
      },
      'tld': [
        '.kr',
        '.\ud55c\uad6d'
      ],
      'region': 'Asia',
      'subregion': 'Eastern Asia',
      'flag': '\ud83c\uddf0\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Kosovo',
        'official': 'Republic of Kosovo',
        'native': {
          'sqi': {
            'official': 'Republika e Kosov\u00ebs',
            'common': 'Kosova'
          },
          'srp': {
            'official': '\u0420\u0435\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u041a\u043e\u0441\u043e\u0432\u043e',
            'common': '\u041a\u043e\u0441\u043e\u0432\u043e'
          }
        }
      },
      'tld': [],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\uddfd\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Kuwait',
        'official': 'State of Kuwait',
        'native': {
          'ara': {
            'official': '\u062f\u0648\u0644\u0629 \u0627\u0644\u0643\u0648\u064a\u062a',
            'common': '\u0627\u0644\u0643\u0648\u064a\u062a'
          }
        }
      },
      'tld': [
        '.kw'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddf0\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Laos',
        'official': "Lao People's Democratic Republic",
        'native': {
          'lao': {
            'official': '\u0eaa\u0eb2\u0e97\u0eb2\u0ea5\u0eb0\u0e99\u0eb0 \u0e8a\u0eb2\u0e97\u0eb4\u0e9b\u0eb0\u0ec4\u0e95 \u0e84\u0ebb\u0e99\u0ea5\u0eb2\u0ea7 \u0e82\u0ead\u0e87',
            'common': '\u0eaa\u0e9b\u0e9b\u0ea5\u0eb2\u0ea7'
          }
        }
      },
      'tld': [
        '.la'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddf1\ud83c\udde6'

    },
    {
      'name': {
        'common': 'Lebanon',
        'official': 'Lebanese Republic',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u0644\u0628\u0646\u0627\u0646\u064a\u0629',
            'common': '\u0644\u0628\u0646\u0627\u0646'
          },
          'fra': {
            'official': 'R\u00e9publique libanaise',
            'common': 'Liban'
          }
        }
      },
      'tld': [
        '.lb'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddf1\ud83c\udde7'

    },
    {
      'name': {
        'common': 'Liberia',
        'official': 'Republic of Liberia',
        'native': {
          'eng': {
            'official': 'Republic of Liberia',
            'common': 'Liberia'
          }
        }
      },
      'tld': [
        '.lr'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf1\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Libya',
        'official': 'State of Libya',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u062f\u0648\u0644\u0629 \u0644\u064a\u0628\u064a\u0627',
            'common': '\u200f\u0644\u064a\u0628\u064a\u0627'
          }
        }
      },
      'tld': [
        '.ly'
      ],
      'region': 'Africa',
      'subregion': 'Northern Africa',
      'flag': '\ud83c\uddf1\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'Saint Lucia',
        'official': 'Saint Lucia',
        'native': {
          'eng': {
            'official': 'Saint Lucia',
            'common': 'Saint Lucia'
          }
        }
      },
      'tld': [
        '.lc'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf1\ud83c\udde8'

    },
    {
      'name': {
        'common': 'Liechtenstein',
        'official': 'Principality of Liechtenstein',
        'native': {
          'deu': {
            'official': 'F\u00fcrstentum Liechtenstein',
            'common': 'Liechtenstein'
          }
        }
      },
      'tld': [
        '.li'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\uddf1\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Sri Lanka',
        'official': 'Democratic Socialist Republic of Sri Lanka',
        'native': {
          'sin': {
            'official': '\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dca\u200d\u0dbb\u0da2\u0dcf\u0dad\u0dcf\u0db1\u0dca\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a \u0dc3\u0db8\u0dcf\u0da2\u0dc0\u0dcf\u0daf\u0dd3 \u0da2\u0db1\u0dbb\u0da2\u0dba',
            'common': '\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0'
          },
          'tam': {
            'official': '\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8 \u0b9a\u0ba9\u0ba8\u0bbe\u0baf\u0b95 \u0b9a\u0bcb\u0b9a\u0bb2\u0bbf\u0b9a\u0b95\u0bcd \u0b95\u0bc1\u0b9f\u0bbf\u0baf\u0bb0\u0b9a\u0bc1',
            'common': '\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8'
          }
        }
      },
      'tld': [
        '.lk',
        '.\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8',
        '.\u0dbd\u0d82\u0d9a\u0dcf'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\uddf1\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Lesotho',
        'official': 'Kingdom of Lesotho',
        'native': {
          'eng': {
            'official': 'Kingdom of Lesotho',
            'common': 'Lesotho'
          },
          'sot': {
            'official': 'Kingdom of Lesotho',
            'common': 'Lesotho'
          }
        }
      },
      'tld': [
        '.ls'
      ],
      'region': 'Africa',
      'subregion': 'Southern Africa',
      'flag': '\ud83c\uddf1\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Lithuania',
        'official': 'Republic of Lithuania',
        'native': {
          'lit': {
            'official': 'Lietuvos Respublikos',
            'common': 'Lietuva'
          }
        }
      },
      'tld': [
        '.lt'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddf1\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Luxembourg',
        'official': 'Grand Duchy of Luxembourg',
        'native': {
          'deu': {
            'official': 'Gro\u00dfherzogtum Luxemburg',
            'common': 'Luxemburg'
          },
          'fra': {
            'official': 'Grand-Duch\u00e9 de Luxembourg',
            'common': 'Luxembourg'
          },
          'ltz': {
            'official': 'Groussherzogtum L\u00ebtzebuerg',
            'common': 'L\u00ebtzebuerg'
          }
        }
      },
      'tld': [
        '.lu'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\uddf1\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Latvia',
        'official': 'Republic of Latvia',
        'native': {
          'lav': {
            'official': 'Latvijas Republikas',
            'common': 'Latvija'
          }
        }
      },
      'tld': [
        '.lv'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddf1\ud83c\uddfb'

    },
    {
      'name': {
        'common': 'Macau',
        'official': "Macao Special Administrative Region of the People's Republic of China",
        'native': {
          'por': {
            'official': 'Regi\u00e3o Administrativa Especial de Macau da Rep\u00fablica Popular da China',
            'common': 'Macau'
          },
          'zho': {
            'official': '\u4e2d\u534e\u4eba\u6c11\u5171\u548c\u56fd\u6fb3\u95e8\u7279\u522b\u884c\u653f\u533a',
            'common': '\u6fb3\u95e8'
          }
        }
      },
      'tld': [
        '.mo'
      ],
      'region': 'Asia',
      'subregion': 'Eastern Asia',
      'flag': '\ud83c\uddf2\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Saint Martin',
        'official': 'Saint Martin',
        'native': {
          'fra': {
            'official': 'Saint-Martin',
            'common': 'Saint-Martin'
          }
        }
      },
      'tld': [
        '.fr',
        '.gp'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf2\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Morocco',
        'official': 'Kingdom of Morocco',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u063a\u0631\u0628\u064a\u0629',
            'common': '\u0627\u0644\u0645\u063a\u0631\u0628'
          },
          'ber': {
            'official': '\u2d5c\u2d30\u2d33\u2d4d\u2d37\u2d49\u2d5c \u2d4f \u2d4d\u2d4e\u2d56\u2d54\u2d49\u2d31',
            'common': '\u2d4d\u2d4e\u2d30\u2d56\u2d54\u2d49\u2d31'
          }
        }
      },
      'tld': [
        '.ma',
        '\u0627\u0644\u0645\u063a\u0631\u0628.'
      ],
      'region': 'Africa',
      'subregion': 'Northern Africa',
      'flag': '\ud83c\uddf2\ud83c\udde6'

    },
    {
      'name': {
        'common': 'Monaco',
        'official': 'Principality of Monaco',
        'native': {
          'fra': {
            'official': 'Principaut\u00e9 de Monaco',
            'common': 'Monaco'
          }
        }
      },
      'tld': [
        '.mc'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\uddf2\ud83c\udde8'

    },
    {
      'name': {
        'common': 'Moldova',
        'official': 'Republic of Moldova',
        'native': {
          'ron': {
            'official': 'Republica Moldova',
            'common': 'Moldova'
          }
        }
      },
      'tld': [
        '.md'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\uddf2\ud83c\udde9'

    },
    {
      'name': {
        'common': 'Madagascar',
        'official': 'Republic of Madagascar',
        'native': {
          'fra': {
            'official': 'R\u00e9publique de Madagascar',
            'common': 'Madagascar'
          },
          'mlg': {
            'official': "Repoblikan'i Madagasikara",
            'common': 'Madagasikara'
          }
        }
      },
      'tld': [
        '.mg'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf2\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Maldives',
        'official': 'Republic of the Maldives',
        'native': {
          'div': {
            'official': '\u078b\u07a8\u0788\u07ac\u0780\u07a8\u0783\u07a7\u0787\u07b0\u0796\u07ad\u078e\u07ac \u0796\u07aa\u0789\u07b0\u0780\u07ab\u0783\u07a8\u0787\u07b0\u0794\u07a7',
            'common': '\u078b\u07a8\u0788\u07ac\u0780\u07a8\u0783\u07a7\u0787\u07b0\u0796\u07ad\u078e\u07ac'
          }
        }
      },
      'tld': [
        '.mv'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\uddf2\ud83c\uddfb'

    },
    {
      'name': {
        'common': 'Mexico',
        'official': 'United Mexican States',
        'native': {
          'spa': {
            'official': 'Estados Unidos Mexicanos',
            'common': 'M\u00e9xico'
          }
        }
      },
      'tld': [
        '.mx'
      ],
      'region': 'Americas',
      'subregion': 'North America',
      'flag': '\ud83c\uddf2\ud83c\uddfd'

    },
    {
      'name': {
        'common': 'Marshall Islands',
        'official': 'Republic of the Marshall Islands',
        'native': {
          'eng': {
            'official': 'Republic of the Marshall Islands',
            'common': 'Marshall Islands'
          },
          'mah': {
            'official': 'Republic of the Marshall Islands',
            'common': 'M\u0327aje\u013c'
          }
        }
      },
      'tld': [
        '.mh'
      ],
      'region': 'Oceania',
      'subregion': 'Micronesia',
      'flag': '\ud83c\uddf2\ud83c\udded'

    },
    {
      'name': {
        'common': 'North Macedonia',
        'official': 'Republic of North Macedonia',
        'native': {
          'mkd': {
            'official': '\u0420\u0435\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u0421\u0435\u0432\u0435\u0440\u043d\u0430 \u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0438\u0458\u0430',
            'common': '\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0438\u0458\u0430'
          }
        }
      },
      'tld': [
        '.mk'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddf2\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Mali',
        'official': 'Republic of Mali',
        'native': {
          'fra': {
            'official': 'R\u00e9publique du Mali',
            'common': 'Mali'
          }
        }
      },
      'tld': [
        '.ml'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf2\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'Malta',
        'official': 'Republic of Malta',
        'native': {
          'eng': {
            'official': 'Republic of Malta',
            'common': 'Malta'
          },
          'mlt': {
            'official': "Repubblika ta ' Malta",
            'common': 'Malta'
          }
        }
      },
      'tld': [
        '.mt'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddf2\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Myanmar',
        'official': 'Republic of the Union of Myanmar',
        'native': {
          'mya': {
            'official': '\u1015\u103c\u100a\u103a\u1011\u1031\u102c\u1004\u103a\u1005\u102f \u101e\u1019\u1039\u1019\u1010 \u1019\u103c\u1014\u103a\u1019\u102c\u1014\u102d\u102f\u1004\u103a\u1004\u1036\u1010\u1031\u102c\u103a',
            'common': '\u1019\u103c\u1014\u103a\u1019\u102c'
          }
        }
      },
      'tld': [
        '.mm'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddf2\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Montenegro',
        'official': 'Montenegro',
        'native': {
          'srp': {
            'official': '\u0426\u0440\u043d\u0430 \u0413\u043e\u0440\u0430',
            'common': '\u0426\u0440\u043d\u0430 \u0413\u043e\u0440\u0430'
          }
        }
      },
      'tld': [
        '.me'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddf2\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Mongolia',
        'official': 'Mongolia',
        'native': {
          'mon': {
            'official': '\u041c\u043e\u043d\u0433\u043e\u043b \u0443\u043b\u0441',
            'common': '\u041c\u043e\u043d\u0433\u043e\u043b \u0443\u043b\u0441'
          }
        }
      },
      'tld': [
        '.mn'
      ],
      'region': 'Asia',
      'subregion': 'Eastern Asia',
      'flag': '\ud83c\uddf2\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Northern Mariana Islands',
        'official': 'Commonwealth of the Northern Mariana Islands',
        'native': {
          'cal': {
            'official': 'Commonwealth of the Northern Mariana Islands',
            'common': 'Northern Mariana Islands'
          },
          'cha': {
            'official': 'Sankattan Siha Na Islas Mari\u00e5nas',
            'common': 'Na Islas Mari\u00e5nas'
          },
          'eng': {
            'official': 'Commonwealth of the Northern Mariana Islands',
            'common': 'Northern Mariana Islands'
          }
        }
      },
      'tld': [
        '.mp'
      ],
      'region': 'Oceania',
      'subregion': 'Micronesia',
      'flag': '\ud83c\uddf2\ud83c\uddf5'

    },
    {
      'name': {
        'common': 'Mozambique',
        'official': 'Republic of Mozambique',
        'native': {
          'por': {
            'official': 'Rep\u00fablica de Mo\u00e7ambique',
            'common': 'Mo\u00e7ambique'
          }
        }
      },
      'tld': [
        '.mz'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf2\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Mauritania',
        'official': 'Islamic Republic of Mauritania',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u0625\u0633\u0644\u0627\u0645\u064a\u0629 \u0627\u0644\u0645\u0648\u0631\u064a\u062a\u0627\u0646\u064a\u0629',
            'common': '\u0645\u0648\u0631\u064a\u062a\u0627\u0646\u064a\u0627'
          }
        }
      },
      'tld': [
        '.mr'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf2\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Montserrat',
        'official': 'Montserrat',
        'native': {
          'eng': {
            'official': 'Montserrat',
            'common': 'Montserrat'
          }
        }
      },
      'tld': [
        '.ms'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf2\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Martinique',
        'official': 'Martinique',
        'native': {
          'fra': {
            'official': 'Martinique',
            'common': 'Martinique'
          }
        }
      },
      'tld': [
        '.mq'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf2\ud83c\uddf6'

    },
    {
      'name': {
        'common': 'Mauritius',
        'official': 'Republic of Mauritius',
        'native': {
          'eng': {
            'official': 'Republic of Mauritius',
            'common': 'Mauritius'
          },
          'fra': {
            'official': 'R\u00e9publique de Maurice',
            'common': 'Maurice'
          },
          'mfe': {
            'official': 'Republik Moris',
            'common': 'Moris'
          }
        }
      },
      'tld': [
        '.mu'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf2\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Malawi',
        'official': 'Republic of Malawi',
        'native': {
          'eng': {
            'official': 'Republic of Malawi',
            'common': 'Malawi'
          },
          'nya': {
            'official': 'Chalo cha Malawi, Dziko la Mala\u0175i',
            'common': 'Mala\u0175i'
          }
        }
      },
      'tld': [
        '.mw'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf2\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Malaysia',
        'official': 'Malaysia',
        'native': {
          'eng': {
            'official': 'Malaysia',
            'common': 'Malaysia'
          },
          'msa': {
            'official': '\u0645\u0644\u064a\u0633\u064a\u0627',
            'common': '\u0645\u0644\u064a\u0633\u064a\u0627'
          }
        }
      },
      'tld': [
        '.my'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddf2\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'Mayotte',
        'official': 'Department of Mayotte',
        'native': {
          'fra': {
            'official': 'D\u00e9partement de Mayotte',
            'common': 'Mayotte'
          }
        }
      },
      'tld': [
        '.yt'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddfe\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Namibia',
        'official': 'Republic of Namibia',
        'native': {
          'afr': {
            'official': 'Republiek van Namibi\u00eb',
            'common': 'Namibi\u00eb'
          },
          'deu': {
            'official': 'Republik Namibia',
            'common': 'Namibia'
          },
          'eng': {
            'official': 'Republic of Namibia',
            'common': 'Namibia'
          },
          'her': {
            'official': 'Republic of Namibia',
            'common': 'Namibia'
          },
          'hgm': {
            'official': 'Republic of Namibia',
            'common': 'Namibia'
          },
          'kwn': {
            'official': 'Republic of Namibia',
            'common': 'Namibia'
          },
          'loz': {
            'official': 'Republic of Namibia',
            'common': 'Namibia'
          },
          'ndo': {
            'official': 'Republic of Namibia',
            'common': 'Namibia'
          },
          'tsn': {
            'official': 'Lefatshe la Namibia',
            'common': 'Namibia'
          }
        }
      },
      'tld': [
        '.na'
      ],
      'region': 'Africa',
      'subregion': 'Southern Africa',
      'flag': '\ud83c\uddf3\ud83c\udde6'

    },
    {
      'name': {
        'common': 'New Caledonia',
        'official': 'New Caledonia',
        'native': {
          'fra': {
            'official': 'Nouvelle-Cal\u00e9donie',
            'common': 'Nouvelle-Cal\u00e9donie'
          }
        }
      },
      'tld': [
        '.nc'
      ],
      'region': 'Oceania',
      'subregion': 'Melanesia',
      'flag': '\ud83c\uddf3\ud83c\udde8'

    },
    {
      'name': {
        'common': 'Niger',
        'official': 'Republic of Niger',
        'native': {
          'fra': {
            'official': 'R\u00e9publique du Niger',
            'common': 'Niger'
          }
        }
      },
      'tld': [
        '.ne'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf3\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Norfolk Island',
        'official': 'Territory of Norfolk Island',
        'native': {
          'eng': {
            'official': 'Territory of Norfolk Island',
            'common': 'Norfolk Island'
          },
          'pih': {
            'official': "Teratri of Norf'k Ailen",
            'common': "Norf'k Ailen"
          }
        }
      },
      'tld': [
        '.nf'
      ],
      'region': 'Oceania',
      'subregion': 'Australia and New Zealand',
      'flag': '\ud83c\uddf3\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Nigeria',
        'official': 'Federal Republic of Nigeria',
        'native': {
          'eng': {
            'official': 'Federal Republic of Nigeria',
            'common': 'Nigeria'
          }
        }
      },
      'tld': [
        '.ng'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf3\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Nicaragua',
        'official': 'Republic of Nicaragua',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de Nicaragua',
            'common': 'Nicaragua'
          }
        }
      },
      'tld': [
        '.ni'
      ],
      'region': 'Americas',
      'subregion': 'Central America',
      'flag': '\ud83c\uddf3\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Niue',
        'official': 'Niue',
        'native': {
          'eng': {
            'official': 'Niue',
            'common': 'Niue'
          },
          'niu': {
            'official': 'Niu\u0113',
            'common': 'Niu\u0113'
          }
        }
      },
      'tld': [
        '.nu'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\uddf3\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Netherlands',
        'official': 'Kingdom of the Netherlands',
        'native': {
          'nld': {
            'official': 'Koninkrijk der Nederlanden',
            'common': 'Nederland'
          }
        }
      },
      'tld': [
        '.nl'
      ],
      'region': 'Europe',
      'subregion': 'Western Europe',
      'flag': '\ud83c\uddf3\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'Norway',
        'official': 'Kingdom of Norway',
        'native': {
          'nno': {
            'official': 'Kongeriket Noreg',
            'common': 'Noreg'
          },
          'nob': {
            'official': 'Kongeriket Norge',
            'common': 'Norge'
          },
          'smi': {
            'official': 'Norgga gonagasriika',
            'common': 'Norgga'
          }
        }
      },
      'tld': [
        '.no'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddf3\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Nepal',
        'official': 'Federal Democratic Republic of Nepal',
        'native': {
          'nep': {
            'official': '\u0928\u0947\u092a\u093e\u0932 \u0938\u0902\u0918\u0940\u092f \u0932\u094b\u0915\u0924\u093e\u0928\u094d\u0924\u094d\u0930\u093f\u0915 \u0917\u0923\u0924\u0928\u094d\u0924\u094d\u0930',
            'common': '\u0928\u0947\u092a\u093e\u0932'
          }
        }
      },
      'tld': [
        '.np'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\uddf3\ud83c\uddf5'

    },
    {
      'name': {
        'common': 'Nauru',
        'official': 'Republic of Nauru',
        'native': {
          'eng': {
            'official': 'Republic of Nauru',
            'common': 'Nauru'
          },
          'nau': {
            'official': 'Republic of Nauru',
            'common': 'Nauru'
          }
        }
      },
      'tld': [
        '.nr'
      ],
      'region': 'Oceania',
      'subregion': 'Micronesia',
      'flag': '\ud83c\uddf3\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'New Zealand',
        'official': 'New Zealand',
        'native': {
          'eng': {
            'official': 'New Zealand',
            'common': 'New Zealand'
          },
          'mri': {
            'official': 'Aotearoa',
            'common': 'Aotearoa'
          },
          'nzs': {
            'official': 'New Zealand',
            'common': 'New Zealand'
          }
        }
      },
      'tld': [
        '.nz'
      ],
      'region': 'Oceania',
      'subregion': 'Australia and New Zealand',
      'flag': '\ud83c\uddf3\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Oman',
        'official': 'Sultanate of Oman',
        'native': {
          'ara': {
            'official': '\u0633\u0644\u0637\u0646\u0629 \u0639\u0645\u0627\u0646',
            'common': '\u0639\u0645\u0627\u0646'
          }
        }
      },
      'tld': [
        '.om'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddf4\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Pakistan',
        'official': 'Islamic Republic of Pakistan',
        'native': {
          'eng': {
            'official': 'Islamic Republic of Pakistan',
            'common': 'Pakistan'
          },
          'urd': {
            'official': '\u0627\u0633\u0644\u0627\u0645\u06cc \u062c\u0645\u06c1\u0648\u0631\u06cc\u06c2 \u067e\u0627\u0643\u0633\u062a\u0627\u0646',
            'common': '\u067e\u0627\u0643\u0633\u062a\u0627\u0646'
          }
        }
      },
      'tld': [
        '.pk'
      ],
      'region': 'Asia',
      'subregion': 'Southern Asia',
      'flag': '\ud83c\uddf5\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Panama',
        'official': 'Republic of Panama',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de Panam\u00e1',
            'common': 'Panam\u00e1'
          }
        }
      },
      'tld': [
        '.pa'
      ],
      'region': 'Americas',
      'subregion': 'Central America',
      'flag': '\ud83c\uddf5\ud83c\udde6'

    },
    {
      'name': {
        'common': 'Pitcairn Islands',
        'official': 'Pitcairn Group of Islands',
        'native': {
          'eng': {
            'official': 'Pitcairn Group of Islands',
            'common': 'Pitcairn Islands'
          }
        }
      },
      'tld': [
        '.pn'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\uddf5\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Peru',
        'official': 'Republic of Peru',
        'native': {
          'aym': {
            'official': 'Piruw Suyu',
            'common': 'Piruw'
          },
          'que': {
            'official': 'Piruw Ripuwlika',
            'common': 'Piruw'
          },
          'spa': {
            'official': 'Rep\u00fablica del Per\u00fa',
            'common': 'Per\u00fa'
          }
        }
      },
      'tld': [
        '.pe'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddf5\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Philippines',
        'official': 'Republic of the Philippines',
        'native': {
          'eng': {
            'official': 'Republic of the Philippines',
            'common': 'Philippines'
          },
          'fil': {
            'official': 'Republic of the Philippines',
            'common': 'Pilipinas'
          }
        }
      },
      'tld': [
        '.ph'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddf5\ud83c\udded'

    },
    {
      'name': {
        'common': 'Palau',
        'official': 'Republic of Palau',
        'native': {
          'eng': {
            'official': 'Republic of Palau',
            'common': 'Palau'
          },
          'pau': {
            'official': 'Beluu er a Belau',
            'common': 'Belau'
          }
        }
      },
      'tld': [
        '.pw'
      ],
      'region': 'Oceania',
      'subregion': 'Micronesia',
      'flag': '\ud83c\uddf5\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Papua New Guinea',
        'official': 'Independent State of Papua New Guinea',
        'native': {
          'eng': {
            'official': 'Independent State of Papua New Guinea',
            'common': 'Papua New Guinea'
          },
          'hmo': {
            'official': 'Independen Stet bilong Papua Niugini',
            'common': 'Papua Niu Gini'
          },
          'tpi': {
            'official': 'Independen Stet bilong Papua Niugini',
            'common': 'Papua Niugini'
          }
        }
      },
      'tld': [
        '.pg'
      ],
      'region': 'Oceania',
      'subregion': 'Melanesia',
      'flag': '\ud83c\uddf5\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Poland',
        'official': 'Republic of Poland',
        'native': {
          'pol': {
            'official': 'Rzeczpospolita Polska',
            'common': 'Polska'
          }
        }
      },
      'tld': [
        '.pl'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\uddf5\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'Puerto Rico',
        'official': 'Commonwealth of Puerto Rico',
        'native': {
          'eng': {
            'official': 'Commonwealth of Puerto Rico',
            'common': 'Puerto Rico'
          },
          'spa': {
            'official': 'Estado Libre Asociado de Puerto Rico',
            'common': 'Puerto Rico'
          }
        }
      },
      'tld': [
        '.pr'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf5\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'North Korea',
        'official': "Democratic People's Republic of Korea",
        'native': {
          'kor': {
            'official': '\uc870\uc120\ubbfc\uc8fc\uc8fc\uc758\uc778\ubbfc\uacf5\ud654\uad6d',
            'common': '\uc870\uc120'
          }
        }
      },
      'tld': [
        '.kp'
      ],
      'region': 'Asia',
      'subregion': 'Eastern Asia',
      'flag': '\ud83c\uddf0\ud83c\uddf5'

    },
    {
      'name': {
        'common': 'Portugal',
        'official': 'Portuguese Republic',
        'native': {
          'por': {
            'official': 'Rep\u00fablica portugu\u00eas',
            'common': 'Portugal'
          }
        }
      },
      'tld': [
        '.pt'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddf5\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Paraguay',
        'official': 'Republic of Paraguay',
        'native': {
          'grn': {
            'official': 'Tet\u00e3 Paragu\u00e1i',
            'common': 'Paragu\u00e1i'
          },
          'spa': {
            'official': 'Rep\u00fablica de Paraguay',
            'common': 'Paraguay'
          }
        }
      },
      'tld': [
        '.py'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddf5\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'Palestine',
        'official': 'State of Palestine',
        'native': {
          'ara': {
            'official': '\u062f\u0648\u0644\u0629 \u0641\u0644\u0633\u0637\u064a\u0646',
            'common': '\u0641\u0644\u0633\u0637\u064a\u0646'
          }
        }
      },
      'tld': [
        '.ps',
        '\u0641\u0644\u0633\u0637\u064a\u0646.'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddf5\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'French Polynesia',
        'official': 'French Polynesia',
        'native': {
          'fra': {
            'official': 'Polyn\u00e9sie fran\u00e7aise',
            'common': 'Polyn\u00e9sie fran\u00e7aise'
          }
        }
      },
      'tld': [
        '.pf'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\uddf5\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Qatar',
        'official': 'State of Qatar',
        'native': {
          'ara': {
            'official': '\u062f\u0648\u0644\u0629 \u0642\u0637\u0631',
            'common': '\u0642\u0637\u0631'
          }
        }
      },
      'tld': [
        '.qa',
        '\u0642\u0637\u0631.'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddf6\ud83c\udde6'

    },
    {
      'name': {
        'common': 'R\u00e9union',
        'official': 'R\u00e9union Island',
        'native': {
          'fra': {
            'official': 'Ile de la R\u00e9union',
            'common': 'La R\u00e9union'
          }
        }
      },
      'tld': [
        '.re'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf7\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Romania',
        'official': 'Romania',
        'native': {
          'ron': {
            'official': 'Rom\u00e2nia',
            'common': 'Rom\u00e2nia'
          }
        }
      },
      'tld': [
        '.ro'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\uddf7\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Russia',
        'official': 'Russian Federation',
        'native': {
          'rus': {
            'official': '\u0420\u043e\u0441\u0441\u0438\u0439\u0441\u043a\u0430\u044f \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044f',
            'common': '\u0420\u043e\u0441\u0441\u0438\u044f'
          }
        }
      },
      'tld': [
        '.ru',
        '.su',
        '.\u0440\u0444'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\uddf7\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Rwanda',
        'official': 'Republic of Rwanda',
        'native': {
          'eng': {
            'official': 'Republic of Rwanda',
            'common': 'Rwanda'
          },
          'fra': {
            'official': 'R\u00e9publique rwandaise',
            'common': 'Rwanda'
          },
          'kin': {
            'official': "Repubulika y'u Rwanda",
            'common': 'Rwanda'
          }
        }
      },
      'tld': [
        '.rw'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf7\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Saudi Arabia',
        'official': 'Kingdom of Saudi Arabia',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064a\u0629 \u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629',
            'common': '\u0627\u0644\u0639\u0631\u0628\u064a\u0629 \u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629'
          }
        }
      },
      'tld': [
        '.sa',
        '.\u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddf8\ud83c\udde6'

    },
    {
      'name': {
        'common': 'Sudan',
        'official': 'Republic of the Sudan',
        'native': {
          'ara': {
            'official': '\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u0633\u0648\u062f\u0627\u0646',
            'common': '\u0627\u0644\u0633\u0648\u062f\u0627\u0646'
          },
          'eng': {
            'official': 'Republic of the Sudan',
            'common': 'Sudan'
          }
        }
      },
      'tld': [
        '.sd'
      ],
      'region': 'Africa',
      'subregion': 'Northern Africa',
      'flag': '\ud83c\uddf8\ud83c\udde9'

    },
    {
      'name': {
        'common': 'Senegal',
        'official': 'Republic of Senegal',
        'native': {
          'fra': {
            'official': 'R\u00e9publique du S\u00e9n\u00e9gal',
            'common': 'S\u00e9n\u00e9gal'
          }
        }
      },
      'tld': [
        '.sn'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf8\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Singapore',
        'official': 'Republic of Singapore',
        'native': {
          'zho': {
            'official': '\u65b0\u52a0\u5761\u5171\u548c\u56fd',
            'common': '\u65b0\u52a0\u5761'
          },
          'eng': {
            'official': 'Republic of Singapore',
            'common': 'Singapore'
          },
          'msa': {
            'official': 'Republik Singapura',
            'common': 'Singapura'
          },
          'tam': {
            'official': '\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0bc2\u0bb0\u0bcd \u0b95\u0bc1\u0b9f\u0bbf\u0baf\u0bb0\u0b9a\u0bc1',
            'common': '\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0bc2\u0bb0\u0bcd'
          }
        }
      },
      'tld': [
        '.sg',
        '.\u65b0\u52a0\u5761',
        '.\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0bc2\u0bb0\u0bcd'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddf8\ud83c\uddec'

    },
    {
      'name': {
        'common': 'South Georgia',
        'official': 'South Georgia and the South Sandwich Islands',
        'native': {
          'eng': {
            'official': 'South Georgia and the South Sandwich Islands',
            'common': 'South Georgia'
          }
        }
      },
      'tld': [
        '.gs'
      ],
      'region': 'Antarctic',
      'subregion': '',
      'flag': '\ud83c\uddec\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Svalbard and Jan Mayen',
        'official': 'Svalbard og Jan Mayen',
        'native': {
          'nor': {
            'official': 'Svalbard og Jan Mayen',
            'common': 'Svalbard og Jan Mayen'
          }
        }
      },
      'tld': [
        '.sj'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddf8\ud83c\uddef'

    },
    {
      'name': {
        'common': 'Solomon Islands',
        'official': 'Solomon Islands',
        'native': {
          'eng': {
            'official': 'Solomon Islands',
            'common': 'Solomon Islands'
          }
        }
      },
      'tld': [
        '.sb'
      ],
      'region': 'Oceania',
      'subregion': 'Melanesia',
      'flag': '\ud83c\uddf8\ud83c\udde7'

    },
    {
      'name': {
        'common': 'Sierra Leone',
        'official': 'Republic of Sierra Leone',
        'native': {
          'eng': {
            'official': 'Republic of Sierra Leone',
            'common': 'Sierra Leone'
          }
        }
      },
      'tld': [
        '.sl'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf8\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'El Salvador',
        'official': 'Republic of El Salvador',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica de El Salvador',
            'common': 'El Salvador'
          }
        }
      },
      'tld': [
        '.sv'
      ],
      'region': 'Americas',
      'subregion': 'Central America',
      'flag': '\ud83c\uddf8\ud83c\uddfb'

    },
    {
      'name': {
        'common': 'San Marino',
        'official': 'Most Serene Republic of San Marino',
        'native': {
          'ita': {
            'official': 'Serenissima Repubblica di San Marino',
            'common': 'San Marino'
          }
        }
      },
      'tld': [
        '.sm'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddf8\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Somalia',
        'official': 'Federal Republic of Somalia',
        'native': {
          'ara': {
            'official': '\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u0635\u0648\u0645\u0627\u0644\u200e\u200e',
            'common': '\u0627\u0644\u0635\u0648\u0645\u0627\u0644\u200e\u200e'
          },
          'som': {
            'official': 'Jamhuuriyadda Federaalka Soomaaliya',
            'common': 'Soomaaliya'
          }
        }
      },
      'tld': [
        '.so'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf8\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Saint Pierre and Miquelon',
        'official': 'Saint Pierre and Miquelon',
        'native': {
          'fra': {
            'official': 'Collectivit\u00e9 territoriale de Saint-Pierre-et-Miquelon',
            'common': 'Saint-Pierre-et-Miquelon'
          }
        }
      },
      'tld': [
        '.pm'
      ],
      'region': 'Americas',
      'subregion': 'North America',
      'flag': '\ud83c\uddf5\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Serbia',
        'official': 'Republic of Serbia',
        'native': {
          'srp': {
            'official': '\u0420\u0435\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u0421\u0440\u0431\u0438\u0458\u0430',
            'common': '\u0421\u0440\u0431\u0438\u0458\u0430'
          }
        }
      },
      'tld': [
        '.rs',
        '.\u0441\u0440\u0431'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddf7\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'South Sudan',
        'official': 'Republic of South Sudan',
        'native': {
          'eng': {
            'official': 'Republic of South Sudan',
            'common': 'South Sudan'
          }
        }
      },
      'tld': [
        '.ss'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\uddf8\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'S\u00e3o Tom\u00e9 and Pr\u00edncipe',
        'official': 'Democratic Republic of S\u00e3o Tom\u00e9 and Pr\u00edncipe',
        'native': {
          'por': {
            'official': 'Rep\u00fablica Democr\u00e1tica do S\u00e3o Tom\u00e9 e Pr\u00edncipe',
            'common': 'S\u00e3o Tom\u00e9 e Pr\u00edncipe'
          }
        }
      },
      'tld': [
        '.st'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\uddf8\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Suriname',
        'official': 'Republic of Suriname',
        'native': {
          'nld': {
            'official': 'Republiek Suriname',
            'common': 'Suriname'
          }
        }
      },
      'tld': [
        '.sr'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddf8\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Slovakia',
        'official': 'Slovak Republic',
        'native': {
          'slk': {
            'official': 'Slovensk\u00e1 republika',
            'common': 'Slovensko'
          }
        }
      },
      'tld': [
        '.sk'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\uddf8\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Slovenia',
        'official': 'Republic of Slovenia',
        'native': {
          'slv': {
            'official': 'Republika Slovenija',
            'common': 'Slovenija'
          }
        }
      },
      'tld': [
        '.si'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddf8\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Sweden',
        'official': 'Kingdom of Sweden',
        'native': {
          'swe': {
            'official': 'Konungariket Sverige',
            'common': 'Sverige'
          }
        }
      },
      'tld': [
        '.se'
      ],
      'region': 'Europe',
      'subregion': 'Northern Europe',
      'flag': '\ud83c\uddf8\ud83c\uddea'

    },
    {
      'name': {
        'common': 'Eswatini',
        'official': 'Kingdom of Eswatini',
        'native': {
          'eng': {
            'official': 'Kingdom of Eswatini',
            'common': 'Eswatini'
          },
          'ssw': {
            'official': 'Umbuso weSwatini',
            'common': 'eSwatini'
          }
        }
      },
      'tld': [
        '.sz'
      ],
      'region': 'Africa',
      'subregion': 'Southern Africa',
      'flag': '\ud83c\uddf8\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Sint Maarten',
        'official': 'Sint Maarten',
        'native': {
          'eng': {
            'official': 'Sint Maarten',
            'common': 'Sint Maarten'
          },
          'fra': {
            'official': 'Saint-Martin',
            'common': 'Saint-Martin'
          },
          'nld': {
            'official': 'Sint Maarten',
            'common': 'Sint Maarten'
          }
        }
      },
      'tld': [
        '.sx'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf8\ud83c\uddfd'

    },
    {
      'name': {
        'common': 'Seychelles',
        'official': 'Republic of Seychelles',
        'native': {
          'crs': {
            'official': 'Repiblik Sesel',
            'common': 'Sesel'
          },
          'eng': {
            'official': 'Republic of Seychelles',
            'common': 'Seychelles'
          },
          'fra': {
            'official': 'R\u00e9publique des Seychelles',
            'common': 'Seychelles'
          }
        }
      },
      'tld': [
        '.sc'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf8\ud83c\udde8'

    },
    {
      'name': {
        'common': 'Syria',
        'official': 'Syrian Arab Republic',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u0639\u0631\u0628\u064a\u0629 \u0627\u0644\u0633\u0648\u0631\u064a\u0629',
            'common': '\u0633\u0648\u0631\u064a\u0627'
          }
        }
      },
      'tld': [
        '.sy',
        '\u0633\u0648\u0631\u064a\u0627.'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddf8\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'Turks and Caicos Islands',
        'official': 'Turks and Caicos Islands',
        'native': {
          'eng': {
            'official': 'Turks and Caicos Islands',
            'common': 'Turks and Caicos Islands'
          }
        }
      },
      'tld': [
        '.tc'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf9\ud83c\udde8'

    },
    {
      'name': {
        'common': 'Chad',
        'official': 'Republic of Chad',
        'native': {
          'ara': {
            'official': '\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u062a\u0634\u0627\u062f',
            'common': '\u062a\u0634\u0627\u062f\u200e'
          },
          'fra': {
            'official': 'R\u00e9publique du Tchad',
            'common': 'Tchad'
          }
        }
      },
      'tld': [
        '.td'
      ],
      'region': 'Africa',
      'subregion': 'Middle Africa',
      'flag': '\ud83c\uddf9\ud83c\udde9'

    },
    {
      'name': {
        'common': 'Togo',
        'official': 'Togolese Republic',
        'native': {
          'fra': {
            'official': 'R\u00e9publique togolaise',
            'common': 'Togo'
          }
        }
      },
      'tld': [
        '.tg'
      ],
      'region': 'Africa',
      'subregion': 'Western Africa',
      'flag': '\ud83c\uddf9\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Thailand',
        'official': 'Kingdom of Thailand',
        'native': {
          'tha': {
            'official': '\u0e23\u0e32\u0e0a\u0e2d\u0e32\u0e13\u0e32\u0e08\u0e31\u0e01\u0e23\u0e44\u0e17\u0e22',
            'common': '\u0e1b\u0e23\u0e30\u0e40\u0e17\u0e28\u0e44\u0e17\u0e22'
          }
        }
      },
      'tld': [
        '.th',
        '.\u0e44\u0e17\u0e22'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddf9\ud83c\udded'

    },
    {
      'name': {
        'common': 'Tajikistan',
        'official': 'Republic of Tajikistan',
        'native': {
          'rus': {
            'official': '\u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u0422\u0430\u0434\u0436\u0438\u043a\u0438\u0441\u0442\u0430\u043d',
            'common': '\u0422\u0430\u0434\u0436\u0438\u043a\u0438\u0441\u0442\u0430\u043d'
          },
          'tgk': {
            'official': '\u04b6\u0443\u043c\u04b3\u0443\u0440\u0438\u0438 \u0422\u043e\u04b7\u0438\u043a\u0438\u0441\u0442\u043e\u043d',
            'common': '\u0422\u043e\u04b7\u0438\u043a\u0438\u0441\u0442\u043e\u043d'
          }
        }
      },
      'tld': [
        '.tj'
      ],
      'region': 'Asia',
      'subregion': 'Central Asia',
      'flag': '\ud83c\uddf9\ud83c\uddef'

    },
    {
      'name': {
        'common': 'Tokelau',
        'official': 'Tokelau',
        'native': {
          'eng': {
            'official': 'Tokelau',
            'common': 'Tokelau'
          },
          'smo': {
            'official': 'Tokelau',
            'common': 'Tokelau'
          },
          'tkl': {
            'official': 'Tokelau',
            'common': 'Tokelau'
          }
        }
      },
      'tld': [
        '.tk'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\uddf9\ud83c\uddf0'

    },
    {
      'name': {
        'common': 'Turkmenistan',
        'official': 'Turkmenistan',
        'native': {
          'rus': {
            'official': '\u0422\u0443\u0440\u043a\u043c\u0435\u043d\u0438\u0441\u0442\u0430\u043d',
            'common': '\u0422\u0443\u0440\u043a\u043c\u0435\u043d\u0438\u044f'
          },
          'tuk': {
            'official': 'T\u00fcrkmenistan',
            'common': 'T\u00fcrkmenistan'
          }
        }
      },
      'tld': [
        '.tm'
      ],
      'region': 'Asia',
      'subregion': 'Central Asia',
      'flag': '\ud83c\uddf9\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Timor-Leste',
        'official': 'Democratic Republic of Timor-Leste',
        'native': {
          'por': {
            'official': 'Rep\u00fablica Democr\u00e1tica de Timor-Leste',
            'common': 'Timor-Leste'
          },
          'tet': {
            'official': 'Rep\u00fablika Demokr\u00e1tika Tim\u00f3r-Leste',
            'common': 'Tim\u00f3r-Leste'
          }
        }
      },
      'tld': [
        '.tl'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddf9\ud83c\uddf1'

    },
    {
      'name': {
        'common': 'Tonga',
        'official': 'Kingdom of Tonga',
        'native': {
          'eng': {
            'official': 'Kingdom of Tonga',
            'common': 'Tonga'
          },
          'ton': {
            'official': 'Kingdom of Tonga',
            'common': 'Tonga'
          }
        }
      },
      'tld': [
        '.to'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\uddf9\ud83c\uddf4'

    },
    {
      'name': {
        'common': 'Trinidad and Tobago',
        'official': 'Republic of Trinidad and Tobago',
        'native': {
          'eng': {
            'official': 'Republic of Trinidad and Tobago',
            'common': 'Trinidad and Tobago'
          }
        }
      },
      'tld': [
        '.tt'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddf9\ud83c\uddf9'

    },
    {
      'name': {
        'common': 'Tunisia',
        'official': 'Tunisian Republic',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u062a\u0648\u0646\u0633\u064a\u0629',
            'common': '\u062a\u0648\u0646\u0633'
          }
        }
      },
      'tld': [
        '.tn'
      ],
      'region': 'Africa',
      'subregion': 'Northern Africa',
      'flag': '\ud83c\uddf9\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Turkey',
        'official': 'Republic of Turkey',
        'native': {
          'tur': {
            'official': 'T\u00fcrkiye Cumhuriyeti',
            'common': 'T\u00fcrkiye'
          }
        }
      },
      'tld': [
        '.tr'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddf9\ud83c\uddf7'

    },
    {
      'name': {
        'common': 'Tuvalu',
        'official': 'Tuvalu',
        'native': {
          'eng': {
            'official': 'Tuvalu',
            'common': 'Tuvalu'
          },
          'tvl': {
            'official': 'Tuvalu',
            'common': 'Tuvalu'
          }
        }
      },
      'tld': [
        '.tv'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\uddf9\ud83c\uddfb'

    },
    {
      'name': {
        'common': 'Taiwan',
        'official': 'Republic of China (Taiwan)',
        'native': {
          'zho': {
            'official': '\u4e2d\u83ef\u6c11\u570b',
            'common': '\u53f0\u7063'
          }
        }
      },
      'tld': [
        '.tw',
        '.\u53f0\u7063',
        '.\u53f0\u6e7e'
      ],
      'region': 'Asia',
      'subregion': 'Eastern Asia',
      'flag': '\ud83c\uddf9\ud83c\uddfc'

    },
    {
      'name': {
        'common': 'Tanzania',
        'official': 'United Republic of Tanzania',
        'native': {
          'eng': {
            'official': 'United Republic of Tanzania',
            'common': 'Tanzania'
          },
          'swa': {
            'official': 'Jamhuri ya Muungano wa Tanzania',
            'common': 'Tanzania'
          }
        }
      },
      'tld': [
        '.tz'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddf9\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Uganda',
        'official': 'Republic of Uganda',
        'native': {
          'eng': {
            'official': 'Republic of Uganda',
            'common': 'Uganda'
          },
          'swa': {
            'official': 'Republic of Uganda',
            'common': 'Uganda'
          }
        }
      },
      'tld': [
        '.ug'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddfa\ud83c\uddec'

    },
    {
      'name': {
        'common': 'Ukraine',
        'official': 'Ukraine',
        'native': {
          'ukr': {
            'official': '\u0423\u043a\u0440\u0430\u0457\u043d\u0430',
            'common': '\u0423\u043a\u0440\u0430\u0457\u043d\u0430'
          }
        }
      },
      'tld': [
        '.ua',
        '.\u0443\u043a\u0440'
      ],
      'region': 'Europe',
      'subregion': 'Eastern Europe',
      'flag': '\ud83c\uddfa\ud83c\udde6'

    },
    {
      'name': {
        'common': 'United States Minor Outlying Islands',
        'official': 'United States Minor Outlying Islands',
        'native': {
          'eng': {
            'official': 'United States Minor Outlying Islands',
            'common': 'United States Minor Outlying Islands'
          }
        }
      },
      'tld': [
        '.us'
      ],
      'region': 'Americas',
      'subregion': 'North America',
      'flag': '\ud83c\uddfa\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Uruguay',
        'official': 'Oriental Republic of Uruguay',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica Oriental del Uruguay',
            'common': 'Uruguay'
          }
        }
      },
      'tld': [
        '.uy'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddfa\ud83c\uddfe'

    },
    {
      'name': {
        'common': 'United States',
        'official': 'United States of America',
        'native': {
          'eng': {
            'official': 'United States of America',
            'common': 'United States'
          }
        }
      },
      'tld': [
        '.us'
      ],
      'region': 'Americas',
      'subregion': 'North America',
      'flag': '\ud83c\uddfa\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Uzbekistan',
        'official': 'Republic of Uzbekistan',
        'native': {
          'rus': {
            'official': '\u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u0423\u0437\u0431\u0435\u043a\u0438\u0441\u0442\u0430\u043d',
            'common': '\u0423\u0437\u0431\u0435\u043a\u0438\u0441\u0442\u0430\u043d'
          },
          'uzb': {
            'official': "O'zbekiston Respublikasi",
            'common': 'O\u2018zbekiston'
          }
        }
      },
      'tld': [
        '.uz'
      ],
      'region': 'Asia',
      'subregion': 'Central Asia',
      'flag': '\ud83c\uddfa\ud83c\uddff'

    },
    {
      'name': {
        'common': 'Vatican City',
        'official': 'Vatican City State',
        'native': {
          'ita': {
            'official': 'Stato della Citt\u00e0 del Vaticano',
            'common': 'Vaticano'
          },
          'lat': {
            'official': 'Status Civitatis Vatican\u00e6',
            'common': 'Vatican\u00e6'
          }
        }
      },
      'tld': [
        '.va'
      ],
      'region': 'Europe',
      'subregion': 'Southern Europe',
      'flag': '\ud83c\uddfb\ud83c\udde6'

    },
    {
      'name': {
        'common': 'Saint Vincent and the Grenadines',
        'official': 'Saint Vincent and the Grenadines',
        'native': {
          'eng': {
            'official': 'Saint Vincent and the Grenadines',
            'common': 'Saint Vincent and the Grenadines'
          }
        }
      },
      'tld': [
        '.vc'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddfb\ud83c\udde8'

    },
    {
      'name': {
        'common': 'Venezuela',
        'official': 'Bolivarian Republic of Venezuela',
        'native': {
          'spa': {
            'official': 'Rep\u00fablica Bolivariana de Venezuela',
            'common': 'Venezuela'
          }
        }
      },
      'tld': [
        '.ve'
      ],
      'region': 'Americas',
      'subregion': 'South America',
      'flag': '\ud83c\uddfb\ud83c\uddea'

    },
    {
      'name': {
        'common': 'British Virgin Islands',
        'official': 'Virgin Islands',
        'native': {
          'eng': {
            'official': 'Virgin Islands',
            'common': 'British Virgin Islands'
          }
        }
      },
      'tld': [
        '.vg'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddfb\ud83c\uddec'

    },
    {
      'name': {
        'common': 'United States Virgin Islands',
        'official': 'Virgin Islands of the United States',
        'native': {
          'eng': {
            'official': 'Virgin Islands of the United States',
            'common': 'United States Virgin Islands'
          }
        }
      },
      'tld': [
        '.vi'
      ],
      'region': 'Americas',
      'subregion': 'Caribbean',
      'flag': '\ud83c\uddfb\ud83c\uddee'

    },
    {
      'name': {
        'common': 'Vietnam',
        'official': 'Socialist Republic of Vietnam',
        'native': {
          'vie': {
            'official': 'C\u1ed9ng h\u00f2a x\u00e3 h\u1ed9i ch\u1ee7 ngh\u0129a Vi\u1ec7t Nam',
            'common': 'Vi\u1ec7t Nam'
          }
        }
      },
      'tld': [
        '.vn'
      ],
      'region': 'Asia',
      'subregion': 'South-Eastern Asia',
      'flag': '\ud83c\uddfb\ud83c\uddf3'

    },
    {
      'name': {
        'common': 'Vanuatu',
        'official': 'Republic of Vanuatu',
        'native': {
          'bis': {
            'official': 'Ripablik blong Vanuatu',
            'common': 'Vanuatu'
          },
          'eng': {
            'official': 'Republic of Vanuatu',
            'common': 'Vanuatu'
          },
          'fra': {
            'official': 'R\u00e9publique de Vanuatu',
            'common': 'Vanuatu'
          }
        }
      },
      'tld': [
        '.vu'
      ],
      'region': 'Oceania',
      'subregion': 'Melanesia',
      'flag': '\ud83c\uddfb\ud83c\uddfa'

    },
    {
      'name': {
        'common': 'Wallis and Futuna',
        'official': 'Territory of the Wallis and Futuna Islands',
        'native': {
          'fra': {
            'official': 'Territoire des \u00eeles Wallis et Futuna',
            'common': 'Wallis et Futuna'
          }
        }
      },
      'tld': [
        '.wf'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\uddfc\ud83c\uddeb'

    },
    {
      'name': {
        'common': 'Samoa',
        'official': 'Independent State of Samoa',
        'native': {
          'eng': {
            'official': 'Independent State of Samoa',
            'common': 'Samoa'
          },
          'smo': {
            'official': 'Malo Sa\u02bboloto Tuto\u02bbatasi o S\u0101moa',
            'common': 'S\u0101moa'
          }
        }
      },
      'tld': [
        '.ws'
      ],
      'region': 'Oceania',
      'subregion': 'Polynesia',
      'flag': '\ud83c\uddfc\ud83c\uddf8'

    },
    {
      'name': {
        'common': 'Yemen',
        'official': 'Republic of Yemen',
        'native': {
          'ara': {
            'official': '\u0627\u0644\u062c\u0645\u0647\u0648\u0631\u064a\u0629 \u0627\u0644\u064a\u0645\u0646\u064a\u0629',
            'common': '\u0627\u0644\u064a\u064e\u0645\u064e\u0646'
          }
        }
      },
      'tld': [
        '.ye'
      ],
      'region': 'Asia',
      'subregion': 'Western Asia',
      'flag': '\ud83c\uddfe\ud83c\uddea'

    },
    {
      'name': {
        'common': 'South Africa',
        'official': 'Republic of South Africa',
        'native': {
          'afr': {
            'official': 'Republiek van Suid-Afrika',
            'common': 'South Africa'
          },
          'eng': {
            'official': 'Republic of South Africa',
            'common': 'South Africa'
          },
          'nbl': {
            'official': 'IRiphabliki yeSewula Afrika',
            'common': 'Sewula Afrika'
          },
          'nso': {
            'official': 'Rephaboliki ya Afrika-Borwa ',
            'common': 'Afrika-Borwa'
          },
          'sot': {
            'official': 'Rephaboliki ya Afrika Borwa',
            'common': 'Afrika Borwa'
          },
          'ssw': {
            'official': 'IRiphabhulikhi yeNingizimu Afrika',
            'common': 'Ningizimu Afrika'
          },
          'tsn': {
            'official': 'Rephaboliki ya Aforika Borwa',
            'common': 'Aforika Borwa'
          },
          'tso': {
            'official': 'Riphabliki ra Afrika Dzonga',
            'common': 'Afrika Dzonga'
          },
          'ven': {
            'official': 'Riphabu\u1e3diki ya Afurika Tshipembe',
            'common': 'Afurika Tshipembe'
          },
          'xho': {
            'official': 'IRiphabliki yaseMzantsi Afrika',
            'common': 'Mzantsi Afrika'
          },
          'zul': {
            'official': 'IRiphabliki yaseNingizimu Afrika',
            'common': 'Ningizimu Afrika'
          }
        }
      },
      'tld': [
        '.za'
      ],
      'region': 'Africa',
      'subregion': 'Southern Africa',
      'flag': '\ud83c\uddff\ud83c\udde6'

    },
    {
      'name': {
        'common': 'Zambia',
        'official': 'Republic of Zambia',
        'native': {
          'eng': {
            'official': 'Republic of Zambia',
            'common': 'Zambia'
          }
        }
      },
      'tld': [
        '.zm'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddff\ud83c\uddf2'

    },
    {
      'name': {
        'common': 'Zimbabwe',
        'official': 'Republic of Zimbabwe',
        'native': {
          'bwg': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'eng': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'kck': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'khi': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'ndc': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'nde': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'nya': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'sna': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'sot': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'toi': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'tsn': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'tso': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'ven': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'xho': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          },
          'zib': {
            'official': 'Republic of Zimbabwe',
            'common': 'Zimbabwe'
          }
        }
      },
      'tld': [
        '.zw'
      ],
      'region': 'Africa',
      'subregion': 'Eastern Africa',
      'flag': '\ud83c\uddff\ud83c\uddfc'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/data/countries.js